{
  "nav": {
    "dashboard": "Dashboard",
    "teacherDashboard": "Teacher Dashboard",
    "projects": "Projects",
    "fairQuote": "Fair Quote",
    "exitFairQuote": "Exit Fair Quote",
    "calendar": "Calendar",
    "products": "Products",
    "colors": "Colors",
    "company": "Company",
    "contacts": "Contacts",
    "applicatorProfiles": "Applicators",
    "courses": "Courses",
    "certifications": "Certifications",
    "certificationDefinitions": "Certification Definitions",
    "userManagement": "User Management",
    "switchEntity": "Switch entity",
    "entities": "Entities",
    "staff": "Staff",
    "overview": "Overview",
    "sections": {
      "projects": "Projects",
      "shop": "Shop",
      "learning": "Learning",
      "admin": "Admin",
      "entity": "Entity"
    }
  },
  "materialTracking": {
    "title": "Material Order",
    "status": {
      "Draft": "To order",
      "Ordered": "Ordered",
      "PartiallyDelivered": "Partially delivered",
      "Delivered": "Delivered"
    },
    "statusLate": "Late delivery",
    "late": "LATE",
    "markOrdered": "Mark as ordered",
    "markOrderedTitle": "Confirm order",
    "markOrderedHint": "Record that the material has been ordered. You can optionally set an estimated delivery date.",
    "estimatedDelivery": "Estimated delivery date",
    "estimatedDeliveryPlaceholder": "Pick a date",
    "orderedOn": "Ordered on",
    "validateDelivery": "Validate delivery",
    "addDeliveryTitle": "Record delivery",
    "addDeliveryHint": "Check what was actually received. Adjust quantities if needed and add or remove items.",
    "deliveryComplete": "Complete delivery",
    "deliveryPartial": "Partial delivery",
    "deliveries": "Deliveries",
    "noLines": "No items recorded",
    "addLine": "Add item",
    "confirmDelivery": "Save delivery",
    "deleteDeliveryTitle": "Delete delivery",
    "deleteDeliveryConfirm": "Are you sure you want to delete this delivery record?",
    "addStock": "Add stock",
    "addStockTitle": "Add manual stock",
    "manualStock": "Manual stock",
    "stockDescription": "Description",
    "stockDescriptionPlaceholder": "e.g. Bag from previous job",
    "stockNotesPlaceholder": "e.g. From Villa Martin",
    "deleteStockTitle": "Remove stock entry",
    "deleteStockConfirm": "Are you sure you want to remove this stock entry?",
    "productName": "Product",
    "quantity": "Qty",
    "unit": "Unit",
    "unitPlaceholder": "e.g. bag 25 kg",
    "notes": "Notes",
    "notesPlaceholder": "Optional note",
    "deliveryNotesPlaceholder": "e.g. Damaged items, missing items",
    "confirmOrder": "Confirm order",
    "draftHint": "No order recorded yet. Click 'Mark as ordered' once you have placed the order.",
    "consumption": "Material needs",
    "productList": "Products to order",
    "order": "Order",
    "orderOnShopify": "Order on masmaya.com",
    "orderAlerts": "Order alerts",
    "daysLate": "{{count}} day late",
    "daysLate_other": "{{count}} days late",
    "sectionOrderWarningTitle": "Ordering for this section only",
    "sectionOrderWarningBody": "Ordering for just this section may cost more than for the whole project: the overall project can sometimes reach bulk thresholds (300kg or 1000kg bags) that a single section can't, especially if site access allows those larger sizes. Consider checking the project total before ordering.",
    "sectionOrderWarningConfirm": "Order anyway"
  },
  "assignedPeople": {
    "add": "Add person",
    "search": "Search…",
    "noResults": "No results",
    "replace": "Replace",
    "remove": "Remove"
  },
  "common": {
    "login": "Login",
    "error": "An error occurred",
    "goHome": "Go Home",
    "loading": "Loading...",
    "cancel": "Cancel",
    "create": "Create",
    "save": "Save",
    "edit": "Edit",
    "remove": "Remove",
    "archive": "Archive",
    "delete": "Delete",
    "open": "Open",
    "add": "Add",
    "close": "Close",
    "zoom": "Zoom",
    "back": "Back",
    "rename": "Rename",
    "unsavedChanges": "Unsaved changes",
    "discardChangesTitle": "Discard changes?",
    "discardChangesConfirm": "You have unsaved changes. Are you sure you want to discard them?",
    "discardChangesAction": "Discard",
    "view": "View",
    "search": "Search…",
    "tooManyResults": "Too many results, refine your search",
    "change": "Change",
    "notFound": "Not found",
    "next": "Next",
    "confirm": "Confirm",
    "selectAll": "Select all",
    "deselectAll": "Deselect all",
    "total": "Total"
  },
  "user": {
    "profile": "Profile",
    "logout": "Log out",
    "noEntity": "No entity selected"
  },
  "products": {
    "title": "Products",
    "createButton": "New Product",
    "createTitle": "Create Product",
    "editTitle": "Edit Product",
    "importButton": "Import CSV",
    "shopifySync": {
      "button": "Sync from Shopify",
      "successTitle": "Shopify sync complete",
      "successMessage": "{{updated}} products updated, {{created}} created",
      "error": "Failed to sync from Shopify"
    },
    "searchPlaceholder": "Search by name, variant or category...",
    "allCategories": "All categories",
    "excludeSamples": "Exclude samples",
    "noData": "No products found",
    "grouped": "Grouped",
    "table": "Table",
    "columns": {
      "category": "Category",
      "name": "Name",
      "variant": "Variant",
      "color": "Color",
      "sizeWeight": "Size / Weight",
      "dimensions": "Dimensions",
      "price": "Price (EUR)"
    },
    "form": {
      "category": "Category",
      "categoryRequired": "Category is required",
      "name": "Product name",
      "nameRequired": "Name is required",
      "variant": "Variant",
      "variantRequired": "Variant is required",
      "color": "Color",
      "sizeWeight": "Size / Weight",
      "dimensions": "Dimensions",
      "price": "Price (EUR)",
      "priceRequired": "Price must be 0 or greater",
      "sku": "SKU",
      "imageUrl": "Image URL",
      "shopifyVariantId": "Shopify Variant ID"
    },
    "delete": {
      "title": "Delete product",
      "confirm": "Are you sure you want to delete \"{{name}}\"? This action cannot be undone."
    },
    "import": {
      "title": "Import products from CSV",
      "description": "Upload a tab-separated file (.csv / .tsv) with the following columns:",
      "selectFile": "Choose file",
      "action": "Import",
      "success": "Import successful",
      "imported": "{{count}} products imported.",
      "close": "Close"
    },
    "backToList": "Back to products"
  },
  "language": {
    "label": "Language",
    "en": "English",
    "fr": "French",
    "de": "German"
  },
  "pages": {
    "login": {
      "pageTitle": "Login"
    },
    "notFound": {
      "message": "Page not found",
      "title": "Oops"
    },
    "milestones": {
      "pageTitle": "Milestones"
    },
    "staff": {
      "pageTitle": "Staff"
    },
    "taskGeneration": {
      "pageTitle": "Task Generation"
    },
    "quote": {
      "pageTitle": "Quote"
    },
    "roomCalculation": {
      "pageTitle": "Room Calculation"
    },
    "company": {
      "pageTitle": "Company"
    },
    "entityDetail": {
      "pageTitle": "Entity Detail"
    },
    "entities": {
      "pageTitle": "Entities"
    }
  },
  "projects": {
    "title": "Projects",
    "createButton": "New Project",
    "createTitle": "Create Project",
    "editTitle": "Edit Project",
    "searchPlaceholder": "Search by name...",
    "allStatuses": "All statuses",
    "noData": "No projects found",
    "late": "Late",
    "noClient": "No client assigned",
    "presentationMode": {
      "enter": "Enter presentation mode (hides prices and internal notes)",
      "exit": "Exit presentation mode"
    },
    "tracking": {
      "title": "Tracking"
    },
    "sequenceGenerator": {
      "title": "Generate task sequence",
      "description": "Automatically generate a timed, dependency-aware Mas Maya task sequence for a project section.",
      "sectionLabel": "Section",
      "startDateLabel": "Start date",
      "generatingPreview": "Generating preview…",
      "generatedSequence": "Generated sequence",
      "steps": "steps",
      "calendarDays": "calendar days",
      "work": "work",
      "dry": "dry",
      "cure": "cure",
      "generationFailed": "Generation failed",
      "unexpectedError": "An unexpected error occurred. Please try again.",
      "confirmAndGenerate": "Confirm & generate",
      "createStepsAndTasks": "Create steps & tasks",
      "cancel": "Cancel",
      "premiumFinish": "Premium finish",
      "repair": "Repair",
      "highTraffic": "High traffic",
      "confirmMessage": "This will create <1>{{stepCount}} project steps</1> and <2>{{taskCount}} tasks</2> in the project. Existing steps and tasks will not be removed.",
      "taskCount_one": "{{count}} task",
      "taskCount_other": "{{count}} tasks",
      "photoLabel": "{{count}}+ photos",
      "stepTypes": {
        "SubstratePreparation": "Substrate preparation",
        "PrimerApplication": "Primer application",
        "BaseLayer": "Base layer",
        "MeshInstallation": "Mesh installation",
        "FinishingCoat": "Finishing coat",
        "Smoothing": "Smoothing",
        "Presealer": "Presealer",
        "Sealer": "Sealer",
        "HeavyDutySealer": "Heavy-duty sealer",
        "CuringStep": "Curing period",
        "ProtectionPeriod": "Protection period",
        "Handover": "Handover"
      }
    },
    "columns": {
      "name": "Name",
      "status": "Status",
      "manager": "Manager",
      "entity": "Entity",
      "startDate": "Start",
      "endDate": "End"
    },
    "status": {
      "Draft": "Draft",
      "Planned": "Planned",
      "InProgress": "In Progress",
      "OnHold": "On Hold",
      "Completed": "Completed",
      "Archived": "Archived",
      "AwaitingDelivery": "Awaiting delivery",
      "Blocked": "Blocked",
      "AwaitingValidation": "Awaiting validation",
      "CorrectionRequired": "Correction required"
    },
    "executionMode": {
      "ExternalOnly": "DIY Project",
      "MasMayaManaged": "Mas Maya Certified Applicator",
      "MasMayaExecuted": "Mas Maya Executed",
      "ExternalOnlyDescription": "The client carries out the work themselves",
      "MasMayaManagedDescription": "Mas Maya certified applicator",
      "MasMayaExecutedDescription": "Carried out by Mas Maya teams"
    },
    "applicators": {
      "title": "Applicator team",
      "selectLabel": "Add applicator",
      "selectPlaceholder": "Search internal applicators...",
      "assign": "Assign",
      "empty": "No applicators assigned yet — use the selector above to add one.",
      "requiresDates": "Set planned start and end dates on the project before assigning applicators.",
      "removeTitle": "Remove applicator",
      "removeConfirm": "Remove {{name}} from the applicator team?"
    },
    "sections": {
      "general": "General information",
      "contact": "Primary contact",
      "documents": "Documents"
    },
    "form": {
      "name": "Name",
      "nameRequired": "Name is required",
      "entity": "Entity",
      "entityRequired": "Entity is required",
      "manager": "Project Manager",
      "managerRequired": "Project manager is required",
      "managerPlaceholder": "Search a user...",
      "managerNoResults": "No users found",
      "status": "Status",
      "date": "Date",
      "startTime": "Start time",
      "endTime": "End time",
      "startDate": "Start date",
      "endDate": "End date",
      "endDateNoSections": "No sections yet",
      "endDateCalculating": "Calculating...",
      "surface": "Total surface (m²)",
      "description": "Description",
      "notes": "Notes",
      "primaryContact": "Primary contact",
      "primaryContactPlaceholder": "Search a contact...",
      "primaryContactNoResults": "No contacts found",
      "primaryContactClear": "— Remove contact",
      "executionMode": "Execution mode",
      "country": "Country",
      "countryRequired": "Country is required",
      "addressLine1": "Street address",
      "city": "City",
      "projectTypeTitle": "Project type",
      "projectTypeSubtitle": "What type of project is this?",
      "sectionSourceTitle": "How would you like to create sections?",
      "sectionSourceSubtitle": "You can always add or import more later.",
      "namePlaceholder": "Les Pins Residence, Villa Dupont…"
    },
    "delete": {
      "title": "Delete project",
      "confirm": "Are you sure you want to delete \"{{name}}\"? This action cannot be undone.",
      "action": "Delete"
    },
    "documents": {
      "dropzoneTitle": "Drop files here or click to upload",
      "dropzoneHint": "Any file type accepted",
      "preview": "Preview",
      "previewUnavailable": "Preview not available for this file type",
      "download": "Download",
      "rename": "Rename",
      "removeTitle": "Remove document",
      "removeConfirm": "Remove \"{{name}}\" from this project?"
    },
    "resources": {
      "title": "Resources",
      "professionalContacts": "Professional contacts",
      "addTitle": "Add a resource",
      "email": "Email",
      "emailPlaceholder": "name@example.com",
      "displayName": "First & last name",
      "displayNamePlaceholder": "John Doe",
      "role": "Role",
      "removeTitle": "Remove resource",
      "removeConfirm": "Remove {{name}} from this project?",
      "columns": {
        "name": "Name",
        "email": "Email",
        "role": "Role",
        "linked": "Account"
      },
      "empty": "No team members assigned yet — add one below.",
      "linked": "Linked",
      "pending": "Pending",
      "roles": {
        "PM": "Project Manager",
        "Worker": "Worker",
        "QualityManager": "Quality Manager"
      },
      "noAvailable": "No one available to assign",
      "certifiedGroup": "Certified applicators",
      "selectCertifiedCompanies": "Companies with a certified applicator"
    },
    "projectSections": {
      "title": "Sections",
      "createTitle": "Add a section",
      "editTitle": "Edit section",
      "add": "Add section",
      "empty": "No sections yet",
      "wet": "Wet",
      "submerged": "Submerged",
      "protected": "Protected",
      "exterior": "Exterior",
      "renameFloor": "Rename floor",
      "deleteTitle": "Delete section",
      "deleteConfirm": "Delete section \"{{label}}\"? This cannot be undone.",
      "columns": {
        "label": "Label",
        "color": "Color",
        "type": "Type",
        "surface": "Surface",
        "finish": "Finish",
        "surfaceM2": "Area",
        "flags": "Flags",
        "workers": "Workers"
      },
      "stepProgress": "Step {{current}} of {{total}}"
    },
    "sectionForm": {
      "label": "Label",
      "color": "Color",
      "colorPlaceholder": "Search a color...",
      "colorClear": "— Remove color",
      "colorNoResults": "No colors found",
      "type": "Type",
      "roomSubtype": "Subtype",
      "substrate": "Substrate",
      "finish": "Finish",
      "surfaceM2": "Area (m²)",
      "exposure": "Exposure",
      "condition": "Support condition",
      "traffic": "Traffic",
      "insideCornerLinearM": "Inside corners (ml)",
      "insideCornerHint": "Do not fold mesh at inside corners",
      "outsideCornerLinearM": "Outside corners (ml)",
      "outsideCornerHint": "Mesh wraps 10 cm each side",
      "isCurved": "Curved surface",
      "isCurvedHint": "Arch, column, vault (+15% waste)",
      "isRepair": "Repair / small patch",
      "isRepairHint": "Minimum forfait quantities",
      "roomWidthM": "Width (m)",
      "roomLengthM": "Length (m)",
      "roomHeightM": "Height (m)",
      "includedSurfaces": "Included surfaces",
      "coatFloor": "Floor",
      "coatWalls": "Walls",
      "coatCeiling": "Ceiling",
      "roomHeightPlaceholder": "Height not provided — 2.5 m used by default for calculations",
      "surfaceConfig": "Per-surface configuration",
      "selectSubstrate": "Select substrate...",
      "selectFinish": "Select finish...",
      "surface": {
        "floor": "Floor",
        "walls": "Walls",
        "ceiling": "Ceiling"
      },
      "roomBreakdown": {
        "surfaceM2": "Room surface",
        "heightM": "Height",
        "heightCoefficient": "Height coefficient",
        "floorM2": "Floor area",
        "wallsM2": "Walls area",
        "ceilingM2": "Ceiling area",
        "totalM2": "Total calculated:",
        "placeholderHeightWarning": "Height not set — 2.5 m used temporarily for calculation",
        "noRoomParams": "Calculation configuration not available"
      },
      "repairForfaitBadge": "Forfait",
      "workers": "Assigned workers",
      "workersPlaceholder": "Select workers...",
      "quantityPreview": "Quantity preview",
      "layerCount": "layer(s)",
      "meshForcedNotice": "Mesh is required for this surface type — cannot be disabled",
      "waterproofMembrane": "Waterproof membrane",
      "waterproofConfirmed": "Present and confirmed",
      "waterproofAbsent": "Absent or unverified",
      "waterproofUnknown": "Select...",
      "waterproofExplanation": "Mas Maya is a water-resistant coating, not a waterproofing system. A waterproof membrane (e.g. Schlüter-KERDI, Aqua-Panel) must be installed before application in wet zones.",
      "waterproofBlockingWarning": "Cannot save: a confirmed waterproof membrane is required for wet zones.",
      "waterproofToPose": "Membrane to install",
      "waterproofWillBeAdded": "No membrane present — the membrane and corner/pipe reinforcement will be added to the material cart.",
      "insideCornerCount": "Number of inside corners",
      "insideCornerCountHint": "Number of inside corner reinforcement pieces to install (e.g. 4 for a rectangular pool)",
      "outsideCornerCount": "Number of outside corners",
      "outsideCornerCountHint": "Number of outside corner reinforcement pieces to install",
      "pipePenetrationCount": "Number of pipe penetrations",
      "pipePenetrationCountHint": "Number of pipe penetration reinforcement pieces to install",
      "system": {
        "standard1Layer": "Dry — 1 layer",
        "premium2Layers": "Dry — 2 layers",
        "mesh2Layers": "Mesh — 2 layers",
        "pool": "Pool — Critical system",
        "exterior": "Exterior — Facade",
        "exteriorFloor": "Exterior — Floor / Terrace"
      },
      "riskLevel": {
        "low": "Low risk",
        "medium": "Moderate risk",
        "high": "High risk",
        "very-high": "Very high risk",
        "critical": "Critical risk"
      },
      "warnings": {
        "deterioratedSupport": "Deteriorated support — Prep required",
        "tilesAlwaysMesh": "Existing tiles — Prep + mesh required (joint movement)",
        "floorMesh": "Floor — Mesh + Presealer + Sealer required",
        "stepsMeshNosing": "Steps — Mesh wrapped over nosing, Presealer + Sealer included",
        "brickBlockMesh": "Jointed substrate — Mesh required",
        "plasterboardMovement": "Plasterboard / partition — Movement risk, mesh required",
        "wetZone": "Bathroom (no direct water contact) — Mesh + protection required",
        "directWaterZone": "Direct water contact — Pool Primer selected automatically",
        "waterproofMembraneRequired": "Waterproof membrane required — must be confirmed before application",
        "masMayaWaterResistant": "Mas Maya is water-resistant but not waterproof — prior membrane is mandatory",
        "submergedZone": "Submerged zone — Pool primer + mesh",
        "exteriorExposure": "Exterior exposure — UV protection required",
        "sealingRequired": "Protection requested — Presealer + Sealer included",
        "heavyDutyRecommended": "Heavy-Duty Sealer recommended for this surface type",
        "poolWaterproofMembrane": "Pool — Waterproof membrane required before Pool Primer",
        "poolWaterline": "Heavy-Duty Sealer required at waterline (±20 cm)",
        "poolAftercare3Weeks": "Ideally wait 3 weeks before filling the pool",
        "exteriorFacadeMesh": "Exterior facade — Mesh + Presealer + Sealer required",
        "drainageSlopeWarning": "Check slope (min 1.5%) and drainage before application",
        "exteriorHeavyDuty": "Exterior floor — Heavy-Duty Sealer required (UV + traffic resistance)",
        "curingTime72h": "Final curing time: minimum 72h after last sealer coat",
        "furnitureMesh": "Wood / MDF — Movement risk, mesh required",
        "insideCornerNoFold": "Inside corners — Do not fold mesh, cut and overlap strips",
        "outsideCornerMesh": "Outside corners — Mesh wrapped 10 cm each side (+0.20 m²/ml)",
        "curvedSurfaceFactor": "Curved surface — +15% coating and mesh waste applied",
        "repairForfait": "Repair — Minimum forfait quantities applied"
      },
      "types": {
        "Wall": "Wall",
        "Pool": "Pool",
        "Facade": "Facade",
        "Steps": "Steps / Stairs",
        "Furniture": "Furniture / Built-in",
        "Room": "Room"
      },
      "typeDescriptions": {
        "Room": "Room with floor, walls and ceiling",
        "Wall": "Interior wall surface",
        "Pool": "Pool or submerged basin",
        "Facade": "Exterior facade",
        "Steps": "Stairs or stair nosings",
        "Furniture": "Furniture, cabinet or object"
      },
      "roomSubtypes": {
        "Bathroom": "Bathroom",
        "Default": "Standard"
      },
      "substrates": {
        "Tiles": "Tiles",
        "Concrete": "Concrete",
        "Wood": "Wood",
        "Brick": "Brick",
        "Block": "Breeze block",
        "Plasterboard": "Plasterboard / partition"
      },
      "finishes": {
        "Standard": "Standard",
        "Premium": "Premium"
      },
      "protectionLevels": {
        "None": "None",
        "Presealer": "Presealer only",
        "PresealerSealer": "Presealer + acrylic sealer",
        "PresealerHeavyDutySealer": "Presealer + heavy-duty sealer"
      },
      "exposures": {
        "None": "None",
        "Wet": "Wet room (bathroom — no direct water contact)",
        "DirectWater": "Direct water contact (shower / basin / tub)",
        "Submerged": "Submerged (pool / fountain)",
        "Outside": "Exterior",
        "WaterProtected": "Water protection (client request)",
        "SolvantProtected": "Solvent protection Heavy-Duty"
      },
      "conditions": {
        "New": "New",
        "Good": "Good condition",
        "Normal": "Normal",
        "Deteriorated": "Deteriorated (Prep required)"
      },
      "trafficLevels": {
        "None": "None",
        "Low": "Low",
        "Medium": "Medium",
        "High": "High"
      },
      "typeChangeReset": "Some fields were reset because they are not compatible with this section type.",
      "underfloorHeating": "Underfloor heating",
      "underfloorHeatingPlaceholder": "Not specified",
      "underfloorHeatingYes": "Yes — underfloor heating present",
      "underfloorHeatingNo": "No — no underfloor heating",
      "underfloorHeatingType": "Heating type",
      "underfloorHeatingUnknown": "Unknown type",
      "underfloorHeatingWater": "Hot water",
      "underfloorHeatingElectric": "Electric",
      "isExteriorRoom": "Exterior",
      "isExteriorRoomHint": "The room is exposed to the outside",
      "isFurnishedRoom": "Furnished room",
      "isFurnishedRoomHint": "The room contains furniture to protect",
      "isOccupiedSite": "Occupied site",
      "isOccupiedSiteHint": "The site is occupied during works",
      "steps": {
        "identity": "Identity",
        "type": "Type",
        "parameters": "Parameters",
        "validation": "Validation"
      },
      "identityTitle": "Section identity",
      "identitySubtitle": "Name this section and associate a Mas Maya colour.",
      "typeTitle": "Section type",
      "typeSubtitle": "What type of surface do you want to configure?",
      "roomConfigTitle": "Room configuration",
      "roomConfigSubtitle": "Enter the dimensions and surfaces to be treated.",
      "standardConfigSubtitle": "Enter the technical characteristics of this surface.",
      "summaryTitle": "Summary",
      "summarySubtitle": "Check the information before creating the section.",
      "colorModes": {
        "SingleColor": "Single colour",
        "PerSurface": "Colour per surface"
      },
      "colorPerSurfaceHint": "Choose a colour for each surface in the Parameters step.",
      "subtypeLabel": "Room subtype",
      "subtypes": {
        "Default": {
          "label": "Standard",
          "description": "Room with no specific configuration"
        },
        "Bathroom": {
          "label": "Bathroom",
          "description": "Premium finish + DirectWater exposure enforced"
        },
        "Kitchen": {
          "label": "Kitchen",
          "description": "Coming soon"
        },
        "Bedroom": {
          "label": "Bedroom",
          "description": "Coming soon"
        },
        "SpaHammam": {
          "label": "Spa / Hammam",
          "description": "Coming soon"
        }
      },
      "comingSoon": "Coming soon",
      "floorColorLabel": "Floor colour",
      "wallsColorLabel": "Walls colour",
      "ceilingColorLabel": "Ceiling colour",
      "createSection": "Create section",
      "selectColorPlaceholder": "Choose a color…",
      "labelPlaceholderRoom": "e.g. Main living room, Upstairs bathroom…",
      "surfacesToTreat": "Surfaces to treat",
      "siteCharacteristics": "Site characteristics",
      "createdTitle": "Section created"
    },
    "consumption": {
      "title": "Product consumption",
      "projectTotal": "Project total",
      "perSection": "Per section"
    },
    "materials": {
      "title": "Material order",
      "projectTotal": "Shopping list",
      "perSection": "Per section",
      "product": "Product",
      "qty": "Qty",
      "cost": "Cost",
      "noProducts": "No products to display",
      "noSections": "No sections yet — add a section in the Sections tab to see material requirements.",
      "productNotFound": "No matching product found in catalogue",
      "orderOnShopify": "Order on masmaya.com",
      "largeVolumeActive": "Large volume access active",
      "largeVolumeActiveDesc": "300 kg and 1000 kg bags are included. If this site cannot accept pallet deliveries, disable large volume access in the project settings.",
      "limitedAccess": "Limited access — only small packaging is offered.",
      "line": {
        "prep": "Mas Maya Prep",
        "poolPrimer": "Mas Maya Pool Primer",
        "primer": "Mas Maya Primer",
        "coating1Layer": "Mas Maya Coating (1 layer)",
        "coating2Layer": "Mas Maya Coating (2 layers)",
        "mixingWater": "Mixing water",
        "mesh": "Mas Maya Mesh",
        "presealer": "Mas Maya Presealer",
        "sealer": "Mas Maya Sealer",
        "heavyDutySealer": "Mas Maya Heavy-Duty Sealer",
        "waterproofMembrane": "Waterproof Membrane",
        "waterproofCornerReinforcement": "Waterproof Corner Reinforcement",
        "waterproofPipeReinforcement": "Waterproof Pipe Reinforcement",
        "pigment": "Pigment {{name}}"
      }
    },
    "quote": {
      "title": "Business Proposal",
      "breakdown": "Detailed breakdown",
      "copyText": "Copy as text",
      "copied": "Copied!",
      "materials": "Materials",
      "labour": "Labour",
      "recipientEmail": "Recipient email",
      "downloadPdf": "Download as PDF",
      "sendByEmail": "Send by email",
      "provisionalDimensionsWarning": "One or more sections use a provisional (unconfirmed) room height. The quantities and cost shown are indicative — emailing and creating a Holded estimate are disabled until the real height is entered on the section.",
      "provisionalBadge": "Provisional",
      "pdfError": "Error generating the PDF",
      "emailSuccess": "Business proposal emailed to {{email}}",
      "emailError": "Error sending the business proposal by email",
      "showPreview": "View business proposal",
      "client": "Client",
      "project": "Project",
      "totalSurface": "Total surface: {{surface}} m²",
      "sectionsProgress": "Sections: {{done}} / {{total}} completed",
      "estimatedTime": "Estimated time: {{hours}} h",
      "totalEstimated": "Total estimated",
      "disclaimer": "This business proposal is indicative and based on the information entered for the project; it may be adjusted after a technical site visit.",
      "sectionsHeading": "Section details",
      "whyTitle": "Why choose Mas Maya?",
      "whyIntro": "Specialists in waterproofing and decorative coatings for pools, wet rooms and façades, Mas Maya designs systems that are durable, elegant and easy to maintain.",
      "whyPoint1Title": "Certified applicator network",
      "whyPoint1Text": "Installation guaranteed by trained, Mas Maya-certified professionals across France.",
      "whyPoint2Title": "Premium finishes",
      "whyPoint2Text": "Refined results and a wide colour palette, built to last.",
      "whyPoint3Title": "Support tailored to you",
      "whyPoint3Text": "DIY, certified applicator, or a turnkey job by our own teams: you choose your level of support.",
      "addSectionToCart": "Add to Mas Maya cart",
      "addProjectToCart": "Add the whole project to Mas Maya cart",
      "timeline": "Application timeline",
      "totals": "Project totals",
      "rawHours": "Raw hours",
      "adjustedHours": "Adjusted hours",
      "totalRawHours": "Total raw hours",
      "totalHours": "Total hours (adjusted)",
      "noSections": "No sections with data to quote.",
      "textHeader": "QUOTE — {{name}}",
      "textSection": "Section",
      "complexityLevel": {
        "low": "Low complexity",
        "normal": "Standard",
        "medium": "Medium complexity",
        "high": "High complexity"
      },
      "tasks": {
        "prep": "Preparation",
        "primer": "Primer",
        "coating": "Coating",
        "smoothing": "Smoothing / polishing",
        "presealer": "Presealer",
        "sealer": "Sealer",
        "heavyDutySealer": "Heavy-Duty Sealer"
      },
      "timelineSteps": {
        "afterPrep": "After prep",
        "afterPrimer": "After primer",
        "betweenLayers": "Between coating layers",
        "afterSmoothing": "After smoothing",
        "afterPresealer": "After presealer",
        "afterSealer": "After sealer",
        "afterHeavyDutySealer": "After Heavy-Duty Sealer",
        "poolFill": "Before filling pool"
      }
    },
    "workflow": {
      "title": "Work Status",
      "notes": "Notes",
      "notesPlaceholder": "Add a note...",
      "photos": "Photos",
      "addPhotos": "Add photos",
      "photoRequired": "At least one photo is required",
      "history": "History",
      "approved": "Quality approved",
      "status": {
        "InProgress": "In Progress",
        "WorkerDone": "Worker Done",
        "QualityApproved": "Approved"
      },
      "changeType": {
        "WorkerDone": "Worker done",
        "QualityApproved": "Approved",
        "QualitySkipped": "Check skipped",
        "QualityRejected": "Rejected"
      },
      "workerDone": {
        "title": "Mark as Done",
        "description": "Upload at least one photo to confirm the work is complete.",
        "action": "Mark as Done",
        "submit": "Confirm Done"
      },
      "quality": {
        "title": "Quality Review",
        "description": "Review the section and approve or reject the work.",
        "action": "Quality Review",
        "approve": "Approve",
        "reject": "Reject",
        "skipCheck": "Skip quality check (no inspection needed)"
      }
    },
    "cards": {
      "sections": "{{done}} / {{total}} sections approved",
      "totalProject": "Project total",
      "labour": "Labour",
      "materials": "Materials",
      "incompleteCalc": "Incomplete calculation",
      "materialsShort": "Mat.",
      "labourShort": "Lab."
    },
    "sectionAttrs": {
      "characteristics": "Characteristics",
      "conditions": "Usage conditions",
      "dimensions": "Surface and geometry",
      "roomDimensions": "Room dimensions",
      "conditionsStandard": "Standard conditions",
      "color": "Color",
      "noColor": "No color defined",
      "surfaceComputed": "Computed surface",
      "surfaceComputedHint": "will be updated after saving",
      "surfaceUsed": "Used surface",
      "surfaceOverridden": "Overridden surface",
      "surfaceOverride": "Manual override",
      "surfaceOverrideHint": "Leave empty to use the computed surface",
      "surfaceOverridePlaceholder": "Surface in m²",
      "noDimensions": "No dimensions set",
      "roomWidth": "Width",
      "roomLength": "Length",
      "roomHeight": "Height",
      "coatWalls": "Coat walls",
      "coatCeiling": "Coat ceiling",
      "coatFloor": "Coat floor",
      "parameters": "Parameters",
      "siteOccupied": "Occupied site",
      "furnishedRoom": "Furnished room",
      "complexityLabel": "complexity",
      "furnishedMarkupLabel": "furnished",
      "occupiedMarkupLabel": "occupied",
      "standardFinishDiscountLabel": "standard finish",
      "editColorsHint": "Edit colors in Settings below",
      "coatingSurfaceSuffix": "m² to coat"
    },
    "bulkColor": {
      "title": "Apply a color to all sections",
      "hint": "The selected color will be applied to all {{count}} section(s) in the project.",
      "removeAll": "Remove color from all sections",
      "confirmTitle": "Confirm application",
      "confirmApply": "Apply color \"{{color}}\" to {{count}} section(s)?",
      "confirmRemove": "Remove color from all {{count}} section(s)?",
      "appliedMessage": "Color applied to the selected sections.",
      "removedMessage": "Color removed from the selected sections."
    },
    "bulkFinishProtection": {
      "title": "Finish and protection (whole project)",
      "hint": "These settings always apply to the entire project — material consumption and labour cost both depend on them.",
      "finishLabel": "Finish",
      "protectionLabel": "Protection",
      "apply": "Apply to whole project",
      "confirmTitle": "Confirm application",
      "confirmApplyFinish": "\"{{finish}}\" finish on {{count}} section(s).",
      "confirmApplyProtection": "\"{{level}}\" protection on {{count}} section(s).",
      "appliedMessage": "Finish and protection applied to the entire project."
    },
    "bulkFinish": {
      "title": "Apply a finish to the whole project",
      "hint": "This changes the finish for every section in the project — material consumption differs by finish.",
      "lockedSectionsHint": "{{count}} section(s) with a locked finish (e.g. stairs, always Premium) will not be affected.",
      "confirmCheckboxLabel": "I understand this applies to the entire project",
      "apply": "Apply to whole project",
      "confirmTitle": "Confirm application",
      "confirmApply": "Apply the \"{{finish}}\" finish to all {{count}} section(s) of the project?",
      "appliedMessage": "Finish applied to the entire project."
    },
    "bulkProtection": {
      "title": "Apply a protection level to the whole project",
      "hint": "This changes the protection level (presealer / sealer) for every eligible section in the project — it affects both material cost and labour cost.",
      "lockedSectionsHint": "{{count}} section(s) (pools, or areas in direct/submerged water contact) always keep their required protection and will not be affected. Room floors also always keep their automatic protection.",
      "confirmCheckboxLabel": "I understand this applies to the entire project",
      "apply": "Apply to whole project",
      "confirmTitle": "Confirm application",
      "confirmApply": "Apply the \"{{level}}\" protection level to all {{count}} section(s) of the project?",
      "appliedMessage": "Protection level applied to the entire project."
    },
    "bulkType": {
      "title": "Apply a type to all sections",
      "hint": "The selected type will be applied to all {{count}} section(s) on this floor.",
      "confirmTitle": "Confirm application",
      "confirmApply": "Apply type \"{{type}}\" to {{count}} section(s)?",
      "coatingStep": "Surfaces to coat",
      "descriptions": {
        "Room": "Room with floor, walls and ceiling",
        "Wall": "Interior wall surface",
        "Pool": "Pool or submerged basin",
        "Facade": "Exterior facade",
        "Steps": "Stairs or step nosing",
        "Furniture": "Furniture, cabinet or object"
      }
    },
    "bulkExclude": {
      "title": "Exclude sections from calculation",
      "hint": "Checked sections will be excluded from material and labour calculations.",
      "apply": "Apply",
      "selectAll": "Select all",
      "selectNone": "Deselect all",
      "banner": "{{count}} section(s) excluded from calculation"
    },
    "extractPlan": {
      "title": "Extract from plan",
      "hint": "Upload an architectural plan to automatically extract rooms and their dimensions.",
      "dropZone": "Click to choose a plan (JPG, PNG, PDF...)",
      "extract": "Analyze plan",
      "noPlans": "No plans uploaded yet. Add images or a PDF above.",
      "uploading": "Uploading...",
      "partialError": "{{count}} page(s) could not be analyzed.",
      "noRoomsFound": "No rooms were detected. Try a clearer image.",
      "converting": "Converting PDF...",
      "extracting": "Analyzing...",
      "error": "Analysis failed. Check that the image is readable and try again.",
      "selectHint": "{{count}} rooms detected. Select the ones to turn into sections.",
      "confidence": "confidence score",
      "heightHint": "Height visible on the plan or to be entered manually",
      "applyHeightToAll": "Height for all rooms",
      "createSections": "Create {{count}} section(s)",
      "creating": "Creating sections...",
      "generatingTasks": "Generating follow-up tasks...",
      "done": "{{count}} section(s) created successfully!",
      "tasksGenerated": "{{count}} follow-up task(s) generated.",
      "surfaceType": "What type of surface do you want to configure?"
    },
    "tasks": {
      "form": {
        "title": "Title",
        "titlePlaceholder": "Task title",
        "category": "Category",
        "priority": "Priority",
        "plannedStart": "Planned start date",
        "plannedEnd": "Planned end date",
        "datePlaceholder": "Select a date",
        "tabDescription": "Description",
        "tabTechnical": "Technical note",
        "tabInternal": "Internal note",
        "tabClient": "Client note",
        "descriptionPlaceholder": "Task description...",
        "technicalPlaceholder": "Technical notes...",
        "internalPlaceholder": "Internal notes (not visible to client)...",
        "clientPlaceholder": "Client instructions...",
        "validationRequired": "Validation required",
        "weatherSensitive": "Weather sensitive",
        "clientVisible": "Client visible",
        "internalOnly": "Internal only",
        "mandatoryPhoto": "Mandatory photos",
        "minPhotos": "Min photos",
        "create": "Create task",
        "save": "Save",
        "cancel": "Cancel",
        "generatedWarning": "This task was generated automatically. Editing this form will mark the task as manually modified.",
        "rejectionTitle": "Rejection subject",
        "rejectionTitlePlaceholder": "e.g. Non-compliant texture",
        "rejectionReason": "Detailed reason",
        "rejectionReasonPlaceholder": "e.g. The left area shows too visible grain difference...",
        "confirmRejection": "Confirm rejection",
        "validationNotes": "Validation notes (optional)",
        "validationNotesPlaceholder": "Notes for the record...",
        "blockingType": "Blocking type",
        "blockingTypeInternal": "Internal (materials, planning, team...)",
        "blockingTypeExternal": "External (other trades, client, weather...)",
        "blockingReason": "Blocking reason",
        "blockingReasonHint": "Explain what needs to happen for this task to unblock — the next reader should know exactly what to do."
      },
      "source": {
        "Generated": "Generated",
        "Modified": "Modified",
        "Manual": "Manual"
      },
      "actions": {
        "title": "Actions",
        "start": "Start task",
        "requestReview": "Request validation",
        "resubmit": "Resubmit",
        "validate": "Validate task",
        "reject": "Reject task",
        "unblock": "Unblock task",
        "block": "Block task",
        "addPhotos": "Add photos",
        "edit": "Edit task"
      },
      "status": {
        "Todo": "To do",
        "Active": "In progress",
        "ReviewRequested": "In review",
        "Completed": "Validated",
        "CorrectionRequired": "Correction required",
        "Blocked": "Blocked",
        "todoMessage": "This task is not yet active. It will start automatically upon validation of the previous task.",
        "awaitingValidation": "Awaiting validation by the manager.",
        "blockedLabel": "Blocked",
        "blockedWhoInternal": "{{name}} needs to act to unblock this",
        "blockedWhoInternalFallback": "Your team",
        "blockedWhoExternal": "Waiting on an external party (client, supplier, another trade) to act",
        "completedLabel": "Task validated",
        "correctionRequired": "Task rejected",
        "instructions": "Instructions: {{instructions}}",
        "submittedPhotos": "Submitted photos",
        "requestReviewTitle": "Add at least {{count}} photo(s) before requesting validation",
        "resubmitTitle": "Add at least {{count}} photo(s) before resubmitting"
      },
      "photos": {
        "title": "Photos",
        "required": "· {{current}}/{{required}} required",
        "added": "Photo added",
        "uploadFailed": "Photo upload failed",
        "uploadFailedMessage": "Unable to send the file. Check the format or try again."
      },
      "notifications": {
        "validated": "Task validated",
        "nextTaskStarted": "The next task has started automatically.",
        "lastTaskValidated": "Last task validated.",
        "validationError": "Error",
        "validationErrorMessage": "Unable to validate the task.",
        "rejected": "Task rejected",
        "rejectedMessage": "The worker has been notified and can correct.",
        "rejectionError": "Error",
        "rejectionErrorMessage": "Unable to reject the task."
      },
      "history": "History",
      "deleteTask": {
        "title": "Delete task",
        "confirm": "Are you sure you want to delete <strong>{{name}}</strong>?",
        "action": "Delete"
      },
      "editModal": "Edit task",
      "noTasksForStep": "No tasks for this step.",
      "noTasksForSection": "No tasks generated for this section.",
      "blockedMessage_one": "Complete {{count}} technical field to generate the workflow: {{fields}}.",
      "blockedMessage_other": "Complete {{count}} technical fields to generate the workflow: {{fields}}.",
      "blockerField": {
        "height": "height",
        "substrate": "substrate",
        "waterproofMembrane": "waterproof membrane"
      },
      "completeConfiguration": "Complete section configuration",
      "readyToGenerate": "This section is ready — the task workflow hasn't been generated yet.",
      "generateNow": "Generate tasks now",
      "ungrouped": "Tasks without a step",
      "taskCount_one": "{{count}} task",
      "taskCount_other": "{{count}} tasks",
      "completedCount_one": "{{count}} validated",
      "completedCount_other": "{{count}} validated",
      "blockedCount_one": "{{count}} blocked",
      "blockedCount_other": "{{count}} blocked",
      "deleteSectionTasks": {
        "title": "Delete all tasks in section",
        "confirm": "Delete {{count}} task(s) from section <strong>{{section}}</strong>? This action is irreversible.",
        "action": "Delete all",
        "tooltip": "Delete all tasks in this section"
      },
      "showPast_one": "Show {{count}} past task",
      "showPast_other": "Show {{count}} past tasks",
      "showFuture_one": "Show {{count}} upcoming task",
      "showFuture_other": "Show {{count}} upcoming tasks",
      "hidePast": "Hide past tasks",
      "hideFuture": "Hide upcoming tasks",
      "dateFrom": "From {{date}}",
      "dateBefore": "Before {{date}}",
      "stepTypes": {
        "SubstratePreparation": "Substrate preparation",
        "PrimerApplication": "Primer application",
        "BaseLayer": "Base layer",
        "MeshInstallation": "Mesh installation",
        "FinishingCoat": "Finishing coat",
        "Smoothing": "Smoothing",
        "Presealer": "Presealer",
        "Sealer": "Sealer",
        "HeavyDutySealer": "Heavy-duty sealer",
        "CuringStep": "Curing",
        "ProtectionPeriod": "Protection period",
        "Handover": "Client handover"
      },
      "sectionTypes": {
        "Wall": "Wall",
        "Floor": "Floor",
        "Bathroom": "Bathroom",
        "Pool": "Pool",
        "Facade": "Facade",
        "Steps": "Steps",
        "Furniture": "Furniture",
        "Room": "Room",
        "Ceiling": "Ceiling"
      },
      "categories": {
        "preparation": "Preparation",
        "primer": "Primer",
        "mesh": "Mesh",
        "base_layer": "Base layer",
        "finishing_layer": "Finishing layer",
        "smoothing": "Smoothing",
        "presealer": "Presealer",
        "sealer": "Sealer",
        "heavy_duty_sealer": "Heavy-duty sealer",
        "curing": "Curing",
        "delivery": "Delivery",
        "inspection": "Inspection",
        "handover": "Handover",
        "custom": "Custom"
      },
      "priorities": {
        "low": "Low",
        "normal": "Normal",
        "high": "High",
        "critical": "Critical"
      },
      "visualStatus": {
        "pending": "To do",
        "inProgress": "In progress",
        "review": "In review",
        "completed": "Validated",
        "rejected": "Rejected",
        "blocked": "Blocked",
        "overdue": "Overdue"
      },
      "blockingType": {
        "Internal": "Internal",
        "External": "External"
      },
      "noSectionsMessage": "Create a section to automatically generate project tracking.",
      "noTasksGeneratedMessage": "No tasks generated. Check the technical data of your sections."
    },
    "projectType": {
      "Renovation": "Renovation project",
      "RenovationDescription": "Rehabilitation of existing surfaces",
      "Neuf": "New build",
      "NeufDescription": "New construction and surfaces"
    },
    "sectionSource": {
      "import": "Import plans",
      "importDescription": "Automatic room detection from your architectural plans",
      "manual": "Create manually",
      "manualDescription": "Define your sections one by one"
    },
    "wizard": {
      "steps": {
        "project": "Project",
        "mode": "Mode",
        "type": "Type",
        "logistics": "Logistics"
      },
      "step1": {
        "title": "New project",
        "subtitle": "Fill in the basic information to create your project."
      },
      "step2": {
        "title": "Execution mode",
        "subtitle": "How will this project be executed?"
      },
      "step3": {
        "title": "Project type",
        "subtitle": "What is the context of this project?"
      },
      "step4": {
        "title": "Site access",
        "subtitle": "Are large pallet deliveries possible on this site?"
      },
      "modes": {
        "ExternalOnly": {
          "label": "DIY Project",
          "description": "The client manages execution with the information provided."
        },
        "MasMayaManaged": {
          "label": "Certified applicator",
          "description": "Project entrusted to a Mas Maya certified applicator."
        },
        "MasMayaExecuted": {
          "label": "Mas Maya Executed",
          "description": "Project executed directly by Mas Maya teams."
        }
      },
      "types": {
        "Renovation": {
          "label": "Renovation",
          "description": "Existing substrate, condition to be assessed."
        },
        "Neuf": {
          "label": "New build",
          "description": "New substrate, pre-filled parameters."
        }
      },
      "access": {
        "large": {
          "label": "Large volume access",
          "description": "Pallet deliveries, 300 kg and 1000 kg containers possible.",
          "hint": "Site access compatible with large volumes and pallet deliveries.",
          "selectLabel": "Yes — pallet deliveries possible"
        },
        "limited": {
          "label": "Limited access",
          "description": "Building, floor, no freight elevator — small packaging only.",
          "hint": "Limited access: large packaging will be automatically disabled.",
          "selectLabel": "No — limited access, small packaging only"
        },
        "fieldLabel": "Large volume site access"
      }
    },
    "milestones": {
      "tabTitle": "Progress",
      "empty": "No milestones yet — they are generated automatically as the project's sections and validations progress.",
      "templates": {
        "project_started": "Project started",
        "preparation_completed": "Preparation completed",
        "surface_approval": "Surface approval",
        "surface_approval_desc": "Your surface is ready for final protection. Please validate the finish before the protection system is applied.",
        "protection_completed": "Protection completed",
        "delivery": "Delivery",
        "custom": "New milestone"
      },
      "status": {
        "Pending": "Pending",
        "AwaitingClient": "Client approval required",
        "Approved": "Approved",
        "Completed": "Completed",
        "Rejected": "Modification requested"
      },
      "approve": "Approve",
      "reject": "Request modification",
      "rejectComment": "Comment (optional)",
      "confirmReject": "Confirm request",
      "approvedByOn": "Approved by {{name}} on {{date}}",
      "approvalStale": "This section was modified after the client approved it — the validation may no longer reflect its current state.",
      "clientApproval": {
        "title": "Surface validation",
        "description": "Your surface is ready for final protection. Please validate the finish before the protection system is applied."
      },
      "payment": {
        "NotDue": "Not due",
        "Due": "Due",
        "Paid": "Paid",
        "markPaid": "Mark as paid"
      }
    },
    "holded": {
      "createEstimate": "Create estimate on Holded",
      "modalDescription": "Choose what the \"{{name}}\" estimate should include.",
      "creating": "Creating...",
      "success": "Estimate created on Holded (ID: {{id}})",
      "error": "Error creating Holded estimate"
    },
    "header": {
      "totalCoatingSurfaceTooltip": "Total surface to coat",
      "totalCoatingSurface": "{{value}} m² to coat"
    },
    "filters": {
      "allManagers": "All managers",
      "allExecutionModes": "All execution modes",
      "lateOnly": "Late only",
      "sortBy": "Sort by",
      "sort": {
        "manual": "Manual order",
        "name": "Name (A–Z)",
        "deadline": "Deadline, soonest",
        "surface": "Surface, largest",
        "progress": "Progress",
        "total": "Total value"
      },
      "clearAll": "Clear filters"
    },
    "kpi": {
      "total": "Total projects",
      "createdThisMonth_one": "+{{count}} this month",
      "createdThisMonth_other": "+{{count}} this month",
      "shareOfBook": "{{pct}}% of the book",
      "clickToIsolate": "Click to isolate",
      "unassignedPm_one": "{{count}} without a manager",
      "unassignedPm_other": "{{count}} without a manager",
      "portfolioValue": "Portfolio value",
      "pricingLoading": "Adding up…",
      "incompleteCalc_one": "{{count}} incomplete calc",
      "incompleteCalc_other": "{{count}} incomplete calcs",
      "upToDate": "Fully priced",
      "avgProgress": "Avg. progress",
      "acrossActiveWork_one": "across {{count}} project",
      "acrossActiveWork_other": "across {{count}} projects"
    },
    "list": {
      "surface": "Surface",
      "progress": "Progress",
      "total": "Total",
      "deadline": "Deadline",
      "lateBy_one": "late {{count}}d",
      "lateBy_other": "late {{count}}d",
      "unassigned": "Unassigned"
    },
    "bulk": {
      "selectedCount_one": "{{count}} selected",
      "selectedCount_other": "{{count}} selected",
      "selectAll": "Select all",
      "changeStatus": "Change status",
      "assignPm": "Assign manager",
      "changeExecutionMode": "Change execution mode",
      "archive": "Archive",
      "archiveTitle": "Archive projects",
      "archiveConfirm_one": "Archive {{count}} project? This can be undone from each project's status later.",
      "archiveConfirm_other": "Archive {{count}} projects? This can be undone from each project's status later.",
      "clearSelection": "Clear selection",
      "statusApplied_one": "Updated {{count}} project",
      "statusApplied_other": "Updated {{count}} projects",
      "pmApplied_one": "Updated {{count}} project",
      "pmApplied_other": "Updated {{count}} projects",
      "executionModeApplied_one": "Updated {{count}} project",
      "executionModeApplied_other": "Updated {{count}} projects",
      "partialFailure": "{{succeeded}} updated, {{failed}} failed"
    }
  },
  "contacts": {
    "title": "Contacts",
    "createButton": "New Contact",
    "createTitle": "Create Contact",
    "editTitle": "Edit Contact",
    "searchPlaceholder": "Search by name, company, email or phone...",
    "allTypes": "All types",
    "noData": "No contacts found",
    "columns": {
      "name": "Name",
      "type": "Type",
      "email": "Email",
      "phone": "Phone",
      "entity": "Entity"
    },
    "type": {
      "Individual": "Individual",
      "Company": "Company"
    },
    "status": {
      "active": "Active",
      "inactive": "Archived"
    },
    "sections": {
      "general": "General information",
      "contact": "Contact details",
      "projects": "Associated projects",
      "enrollments": "Course sessions",
      "training": "Training & Certifications"
    },
    "form": {
      "entity": "Entity",
      "entityRequired": "Entity is required",
      "type": "Type",
      "displayName": "Display name",
      "displayNameRequired": "Display name is required",
      "firstName": "First name",
      "lastName": "Last name",
      "companyName": "Company name",
      "email": "Email",
      "phone": "Phone",
      "addressLine1": "Address",
      "addressLine2": "Address (line 2)",
      "postalCode": "Postal code",
      "city": "City",
      "country": "Country (ISO Alpha-2)",
      "notes": "Notes"
    },
    "archive": {
      "title": "Archive contact",
      "confirm": "Are you sure you want to archive \"{{name}}\"? They will no longer be visible by default.",
      "action": "Archive"
    },
    "projectColumns": {
      "name": "Project",
      "status": "Status"
    },
    "enrollmentColumns": {
      "course": "Course",
      "date": "Date",
      "teacher": "Teacher",
      "status": "Status"
    },
    "discount": {
      "sectionTitle": "Discount & Certification",
      "permanentDiscount": "Permanent discount",
      "baseDiscount": "Base discount",
      "manualOverride": "Manual discount override",
      "manualOverrideHint": "Admin override (10%–35% in 2.5% steps). Applies if higher than training-based discount.",
      "linkedStudent": "Linked student ID",
      "linkedStudentHint": "Link a student record to enable certification-based discounts",
      "linked": "Linked"
    },
    "installer": {
      "sectionTitle": "Referenced Installer",
      "badge": "Referenced Installer",
      "status": "Installer status",
      "active": "Active",
      "inactive": "Not listed",
      "enable": "Enable listing",
      "disable": "Remove listing",
      "requirement": "Certification",
      "certificationLinked": "Student linked",
      "certificationRequired": "No student linked — certification required"
    },
    "hierarchy": {
      "linkedContacts": "Linked contacts",
      "noLinkedContacts": "No linked individual contacts.",
      "parentCompany": "Parent company",
      "noParentCompany": "No parent company linked.",
      "link": "Link",
      "unlink": "Unlink",
      "unlinkTitle": "Unlink contact",
      "unlinkConfirm": "Unlink \"{{name}}\" from this company?",
      "unlinkParentConfirm": "Remove link to \"{{name}}\"?",
      "linkToCompany": "Link to a company",
      "selectIndividual": "Select an individual contact...",
      "selectCompany": "Select a company..."
    },
    "professional": {
      "sectionTitle": "Professional information",
      "siren": "SIREN",
      "sirenRequired": "SIREN is required",
      "sirenFormat": "SIREN must be exactly 9 digits",
      "sirenNotFound": "No company found for this SIREN",
      "vatNumber": "VAT number",
      "vatRequired": "VAT number is required",
      "companyNameHint": "Name used by your contact (may differ from legal name)",
      "companyNameRequired": "Company name is required",
      "legalName": "Legal company name",
      "registeredAddress": "Registered address",
      "companyStatus": "Company status",
      "statusRadiated": "Radiated",
      "director": "Director",
      "activity": "Business activity"
    }
  },
  "colors": {
    "title": "Color Selector",
    "colorCount": "colors",
    "importButton": "Import CSV Matrix",
    "exportButton": "Export CSV Matrix",
    "importSuccess": "Import successful",
    "importSuccessCount": "{{count}} colors imported.",
    "noData": "No color formulas loaded. Import a CSV matrix to get started.",
    "noCollection": "Other",
    "weight": "Weight (kg)",
    "weightHint": "Pigment quantities scale with weight",
    "coating": "Coating base",
    "pigments": "Pigments",
    "productNotFound": "Product not found in catalog",
    "needed": "needed:",
    "unit": "unit",
    "subtotal": "Subtotal:",
    "grandTotal": "Total",
    "pickColor": "Pick a colour",
    "searchPlaceholder": "Search colors...",
    "noResults": "No colors match your search",
    "removeColor": "Remove color"
  },
  "courses": {
    "enroll": {
      "search": "Search contacts",
      "searchPlaceholder": "Search by name or email...",
      "contact": "Contact",
      "contactPlaceholder": "Select a contact...",
      "noResults": "No contacts found",
      "action": "Enroll"
    }
  },
  "teachers": {
    "title": "Certified Teachers",
    "createButton": "New Teacher",
    "createTitle": "Add Teacher",
    "editTitle": "Edit Teacher",
    "backToList": "Back to teachers",
    "searchPlaceholder": "Search by name, email or country...",
    "allStatuses": "All statuses",
    "noData": "No teachers found",
    "inactive": "Inactive",
    "noCertifiedLevels": "No certified levels",
    "columns": {
      "name": "Name",
      "certification": "Certification",
      "levels": "Certified levels",
      "languages": "Languages",
      "validity": "Valid until"
    },
    "certificationStatus": {
      "Pending": "Pending",
      "Active": "Active",
      "Expired": "Expired",
      "Revoked": "Revoked"
    },
    "form": {
      "fullName": "Full name",
      "fullNameRequired": "Full name is required",
      "email": "Email",
      "emailRequired": "Email is required",
      "country": "Country (ISO Alpha-2)",
      "languages": "Languages",
      "certifiedLevels": "Certified levels",
      "specialties": "Specialties",
      "specialtiesPlaceholder": "Pool, Exterior...",
      "isActive": "Active teacher"
    },
    "certify": {
      "title": "Certify teacher",
      "action": "Certify",
      "levels": "Levels to certify",
      "levelsRequired": "Select at least one level",
      "certificationDate": "Certification date",
      "expirationDate": "Expiration date",
      "expirationRequired": "Expiration date is required",
      "selfCertifyNote": "A teacher cannot self-certify. This action is reserved for Mas Maya administrators.",
      "expired": "Certification expired"
    },
    "revoke": {
      "title": "Revoke certification",
      "confirm": "Are you sure you want to revoke this teacher's certification? They will no longer be able to teach sessions.",
      "action": "Revoke"
    },
    "info": {
      "certification": "Certification",
      "profile": "Profile",
      "certifiedOn": "Certified on",
      "expiresOn": "Expires on"
    },
    "sessions": {
      "title": "Assigned sessions",
      "empty": "No sessions assigned"
    },
    "evaluations": {
      "title": "Student evaluations",
      "student": "Student",
      "score": "Score",
      "notes": "Notes",
      "date": "Date"
    },
    "evaluate": {
      "title": "Evaluate student",
      "addButton": "Add evaluation",
      "action": "Submit",
      "student": "Student",
      "studentPlaceholder": "Select a student...",
      "noStudents": "No students found",
      "score": "Score (1–5)",
      "scoreHint": "1 = needs improvement, 5 = excellent",
      "notes": "Notes"
    }
  },
  "students": {
    "title": "Students",
    "createButton": "New Student",
    "createTitle": "Add Student",
    "searchPlaceholder": "Search by name or email...",
    "noData": "No students found",
    "type": {
      "Individual": "Individual",
      "Professional": "Professional"
    },
    "columns": {
      "name": "Name",
      "email": "Email",
      "type": "Type",
      "company": "Company",
      "country": "Country",
      "language": "Language"
    },
    "form": {
      "firstName": "First name",
      "firstNameRequired": "First name is required",
      "lastName": "Last name",
      "lastNameRequired": "Last name is required",
      "email": "Email",
      "emailRequired": "Email is required",
      "phone": "Phone",
      "type": "Type",
      "companyName": "Company name"
    }
  },
  "certifications": {
    "title": "Applicator Certifications",
    "allLevels": "All levels",
    "allStatuses": "All statuses",
    "searchPlaceholder": "Search by name or email...",
    "noData": "No certifications found",
    "viewLevels": "View level definitions",
    "publicPage": "Public page",
    "status": {
      "Pending": "Pending",
      "Passed": "Passed",
      "Failed": "Failed",
      "Expired": "Expired"
    },
    "columns": {
      "student": "Student",
      "level": "Level",
      "status": "Status",
      "issuedAt": "Issued on",
      "expiration": "Expires on",
      "session": "Session",
      "finishes": "Expert finishes",
      "certifications": "Certifications"
    },
    "issue": {
      "title": "Issue certification",
      "action": "Issue",
      "levelRequired": "Level is required",
      "level": "Certification level",
      "issuedAt": "Issue date",
      "expirationDate": "Expiration date",
      "notes": "Notes",
      "basicNote": "Basic certifications are auto-validated after full participation and cannot be failed.",
      "allLevelsIssued": "This student already has certifications for all levels.",
      "alreadyIssued": "Certification already issued for this level",
      "absentCannotIssue": "Cannot issue a certification to an absent student",
      "expertFinishes": "Expert finishes validated",
      "terrazzoMetadata": "Terrazzo — base + 3 incrustation colors",
      "terrazzoPlaceholder": "e.g. White base, black, gold, rust"
    },
    "update": {
      "title": "Update certification",
      "action": "Save",
      "status": "Status",
      "addFinish": "Validate expert finish",
      "selectFinish": "Select a finish...",
      "validateFinish": "Validate finish"
    },
    "levels": {
      "title": "Applicator Certification Levels",
      "subtitle": "Requirements and scope for each certification level",
      "skills": "Application scope",
      "products": "Required products",
      "finishes": "Creative finishes",
      "canFail": "Can be failed",
      "cannotFail": "Cannot be failed",
      "autoValidates": "Auto-validates"
    },
    "levelDefinitions": {
      "basic": {
        "title": "Basic Applicator",
        "skills": {
          "interiorWalls": "Interior walls",
          "interiorFloors": "Interior floors",
          "interiorCeilings": "Interior ceilings",
          "cleanStableSubstrates": "Clean, stable substrates"
        }
      },
      "intermediate": {
        "title": "Intermediate Applicator",
        "skills": {
          "protectedExteriors": "Protected exteriors",
          "complexInteriors": "Complex interiors",
          "deterioratedSubstrates": "Deteriorated substrates",
          "correctivePrep": "Corrective preparation"
        }
      },
      "expert": {
        "title": "Expert Applicator",
        "skills": {
          "wetRooms": "Wet rooms",
          "showers": "Showers",
          "bathtubs": "Bathtubs",
          "pools": "Pools",
          "fountains": "Fountains",
          "facades": "Facades",
          "wetAreas": "Wet areas"
        }
      },
      "expertFinishes": {
        "title": "Expert Finishes Applicator",
        "skills": {
          "advancedCreativeFinishes": "Advanced and creative finishes"
        },
        "finishes": {
          "pise": "Pisé (rammed earth)",
          "castConcreteAcetate": "Cast concrete (acetate)",
          "woodFormworkConcrete": "Wood-formwork concrete",
          "burntEffect": "Burnt effect",
          "brushedConcrete": "Brushed concrete",
          "rawSandEffect": "Raw sand effect",
          "shouSugiBan": "Shou Sugi Ban",
          "naturalStoneEffect": "Natural stone effect",
          "terrazzoEffect": "Terrazzo effect (base + 3 inlays)"
        }
      },
      "products": {
        "preparation": "Preparation",
        "base": "Base"
      }
    },
    "public": {
      "subtitle": "{{count}} validated certification(s)",
      "noData": "No certifications found for this applicator.",
      "footer": "Certified by Mas Maya · masmaya.fr"
    },
    "admin": {
      "newDefinition": "New definition",
      "editDefinition": "Edit definition",
      "noDefinitions": "No definitions.",
      "form": {
        "name": "Name",
        "slug": "Slug",
        "slugDescription": "Unique URL identifier (e.g. basic-applicator)",
        "category": "Category",
        "prerequisites": "Prerequisites",
        "description": "Description",
        "sortOrder": "Display order",
        "isActive": "Active"
      },
      "columns": {
        "name": "Name",
        "slug": "Slug",
        "category": "Category",
        "prerequisites": "Prerequisites",
        "order": "Order",
        "active": "Active"
      }
    }
  },
  "finishEvaluation": {
    "modalTitle": "Expert Finish Evaluation",
    "evaluateAction": "Evaluate finish",
    "finishType": "Finish type",
    "finishPlaceholder": "Select a finish...",
    "finishRequired": "Please select a finish type",
    "score": "Score (0–10)",
    "willFail": "Below pass threshold",
    "photos": "Photos",
    "photosBefore": "Before photos",
    "photosDuring": "In-progress photos",
    "photosAfter": "After photos",
    "dropPhotos": "Drop images or click to browse",
    "photosRequired": "At least one before photo and one after photo are required",
    "terrazzoColors": "Terrazzo colors",
    "terrazzoBase": "Base color",
    "terrazzoColor1": "Incrustation 1",
    "terrazzoColor2": "Incrustation 2",
    "terrazzoColor3": "Incrustation 3",
    "terrazzoColorsRequired": "All four terrazzo colors are required",
    "submit": "Submit evaluation",
    "uploading": "Uploading photos…",
    "historyTitle": "Expert Finish Evaluations",
    "attempts": "{{count}} attempt(s)",
    "finishes": {
      "Pise": {
        "label": "Pisé effect",
        "description": "Layer-by-layer compaction mimicking traditional pisé."
      },
      "BetonCoule": {
        "label": "Acetate poured concrete",
        "description": "Concrete poured with acetate sheet for a smooth, glossy finish."
      },
      "BetonCoffrage": {
        "label": "Wood-form concrete",
        "description": "Wood plank imprint in concrete for a structured texture."
      },
      "EffetBrule": {
        "label": "Burnt effect",
        "description": "Very firm stone or stainless trowel to create a charred texture."
      },
      "BetonBrosse": {
        "label": "Brushed concrete",
        "description": "Brushing fresh concrete to create a textured surface with grooves."
      },
      "EffetBrut": {
        "label": "Raw effect with sand traces",
        "description": "Raw finish leaving visible sand traces on the surface."
      },
      "ShouSugiBan": {
        "label": "Charred wood Shou Sugi Ban",
        "description": "Japanese wood-burning technique applied during demolding."
      },
      "EffetPierre": {
        "label": "Natural stone effect",
        "description": "Imitation of natural stone texture and appearance."
      },
      "EffetTerrazzo": {
        "label": "Terrazzo effect",
        "description": "Terrazzo with base colour and 3 coloured inlays."
      }
    }
  },
  "certificates": {
    "title": "Digital Certificates",
    "status": {
      "Active": "Active",
      "Expired": "Expired",
      "Revoked": "Revoked"
    },
    "verify": {
      "title": "Certificate Verification",
      "code": "Verification code",
      "level": "Certification level",
      "specialties": "Specialties",
      "issued": "Issued",
      "expires": "Expires",
      "revokedOn": "Revoked on",
      "validNote": "This certificate has been issued by Mas Maya and is cryptographically verifiable.",
      "notFound": "Certificate not found",
      "notFoundDesc": "No certificate exists with this verification code.",
      "link": "Verify"
    },
    "revoke": {
      "title": "Revoke certificate",
      "confirm": "Are you sure you want to revoke this certificate? This action cannot be undone.",
      "action": "Revoke",
      "defaultReason": "Revoked by administrator"
    }
  },
  "evaluation": {
    "modalTitle": "Certification evaluation",
    "evaluateCertification": "Evaluate certification",
    "selectStudent": "Student",
    "studentPlaceholder": "Select a student...",
    "studentRequired": "Please select a student",
    "criteria": "Evaluation criteria",
    "scoreRange": "Score 0–10",
    "finalScore": "Global score",
    "willPass": "Will pass",
    "willFail": "{{count}} criterion/criteria failing",
    "failAlert": "The following criteria are below the threshold: {{criteria}}",
    "teacherNotes": "Teacher notes",
    "notesPlaceholder": "Observations, improvement points...",
    "noCriteria": "No criteria defined for this level",
    "submit": "Submit evaluation",
    "history": "Evaluation history",
    "passed": "Passed",
    "failed": "Failed",
    "failedCriteria": "Failed criteria",
    "retrySessions": "Available retry sessions",
    "seats": "seats"
  },
  "dashboard": {
    "title": "Dashboard",
    "subtitle": "Overview of your training activity",
    "upcomingSessions": "Upcoming sessions",
    "stats": {
      "students": "Students",
      "teachers": "Teachers",
      "activeCerts": "Active certs",
      "pendingCerts": "Pending",
      "upcomingSessions": "Upcoming (30d)",
      "passedThisYear": "Passed this year"
    },
    "projectsOverview": {
      "title": "Projects",
      "active": "Active",
      "blocked": "Blocked",
      "awaitingValidation": "Awaiting validation",
      "late": "Late",
      "needsAttention": "Needs attention"
    }
  },
  "teacherDashboard": {
    "welcomeLabel": "Welcome back",
    "noProfile": "No teacher profile",
    "noProfileDesc": "No teacher profile is linked to your account.",
    "upcomingSessions": "Your upcoming sessions",
    "recentEvaluations": "Recent evaluations",
    "noSessions": "No sessions assigned",
    "stats": {
      "upcoming": "Upcoming",
      "sessions": "Total sessions",
      "evaluations": "Evaluations"
    }
  },
  "studentPortal": {
    "title": "Student Portal",
    "subtitle": "Access your training results, certifications and upcoming sessions.",
    "emailLabel": "Your email address",
    "emailPlaceholder": "student@example.com",
    "lookup": "Access my profile",
    "notFound": "No account found",
    "profileLabel": "My Profile",
    "profileNotFound": "Profile not found",
    "upcomingSessions": "Upcoming sessions",
    "pastSessions": "Past sessions",
    "footer": "Mas Maya Training · masmaya.fr",
    "privacyNote": "Only your training data is displayed. No account or password required."
  },
  "enroll": {
    "title": "Register for a session",
    "firstName": "First name",
    "lastName": "Last name",
    "email": "Email address",
    "type": "Type",
    "company": "Company / Organisation",
    "country": "Country (2-letter code)",
    "language": "Preferred language",
    "seatsLeft": "{{count}} seat(s) left",
    "submit": "Register",
    "requiredFields": "Please fill in all required fields.",
    "notOpen": "Registration not open",
    "notOpenDesc": "This session is not currently open for registration.",
    "sessionNotFound": "Session not found",
    "successTitle": "Registration confirmed!",
    "successDesc": "Your spot is reserved. You will receive a confirmation by email.",
    "viewProfile": "View my profile",
    "error": "An error occurred. Please try again.",
    "privacyNote": "Your data is used solely for training purposes.",
    "professional": {
      "siren": "SIREN Number",
      "sirenDesc": "9 digits — automatic lookup via Pappers",
      "sirenRequired": "SIREN number is required (9 digits).",
      "sirenNotFound": "Company not found or invalid SIREN.",
      "vatNumber": "VAT Number",
      "vatRequired": "VAT number is required.",
      "companyRequired": "Company name is required.",
      "companyNameDesc": "Name used commercially (may differ from legal name)",
      "director": "Director",
      "radiated": "Company dissolved / closed"
    }
  },
  "cart": {
    "title": "Cart",
    "empty": "Cart is empty",
    "clear": "Clear cart",
    "clearTitle": "Clear cart",
    "clearConfirm": "Remove all items from this cart?",
    "clearAction": "Clear",
    "training": "Training",
    "subtotal": "Subtotal",
    "discount": "Discount",
    "total": "Total",
    "columns": {
      "item": "Item",
      "unitPrice": "Unit price",
      "qty": "Qty",
      "total": "Total"
    },
    "discountReason": {
      "base": "Base rate",
      "manual_override": "Manual admin discount",
      "cart_training_incentive": "Unlocked by adding training",
      "certification_Basic": "Basic certification",
      "certification_Intermediate": "Intermediate certification",
      "certification_Expert": "Expert certification",
      "certification_ExpertFinishes": "Expert Finishes certification"
    },
    "upsell": {
      "title": "Unlock a discount",
      "addTraining": "Add {{title}} to cart",
      "level": {
        "Basic": "Basic",
        "Intermediate": "Intermediate",
        "Expert": "Expert",
        "ExpertFinishes": "Expert Finishes"
      }
    }
  },
  "entities": {
    "title": "Entities",
    "createButton": "New Entity",
    "createTitle": "Create Entity",
    "editTitle": "Edit Entity",
    "searchPlaceholder": "Search by name, code or country...",
    "showArchived": "Show archived",
    "noData": "No entities found",
    "noUsers": "No users assigned",
    "viewUsers": "View users",
    "columns": {
      "name": "Name",
      "code": "Code",
      "country": "Country",
      "status": "Status",
      "users": "Users"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "sections": {
      "general": "General information",
      "users": "Assigned users",
      "staff": "Staff members"
    },
    "noStaff": "No staff members for this entity",
    "form": {
      "name": "Name",
      "nameRequired": "Name is required",
      "code": "Internal code",
      "codePlaceholder": "e.g. CORP-FR",
      "country": "Country (ISO Alpha-2)",
      "countryPlaceholder": "Select a country",
      "countryRequired": "Country is required",
      "currency": "Currency (ISO 4217)",
      "timezone": "Timezone",
      "email": "Contact email",
      "logoUrl": "Logo URL",
      "isActive": "Active"
    },
    "archive": {
      "title": "Archive entity",
      "confirm": "Are you sure you want to archive \"{{name}}\"? It will no longer be visible by default.",
      "confirm_action": "Archive"
    },
    "assignUser": {
      "title": "Assign a user",
      "button": "Assign user",
      "searchLabel": "Search user",
      "searchPlaceholder": "Name or email...",
      "noResults": "No users found",
      "selected": "Selected",
      "assign": "Assign"
    },
    "removeUser": {
      "title": "Remove user",
      "confirm": "Remove {{name}} from this entity?"
    },
    "managers": {
      "title": "Managers",
      "role": "Entity manager",
      "noAvailable": "No users available"
    },
    "userColumns": {
      "name": "Name",
      "email": "Email",
      "assignedOn": "Assigned on"
    },
    "quoteConfig": {
      "title": "Quote configuration",
      "subtitle": "Default values used for consumption calculation",
      "consumptionRates": "Consumption rates",
      "wasteFactors": "Waste factors",
      "labourRates": "Labour rates",
      "complexityMultipliers": "Complexity multipliers",
      "fields": {
        "coating1LayerKgPerM2": "Coating 1 layer",
        "coating2LayerKgPerM2": "Coating 2 layers",
        "mixingWaterWallLPerKg": "Mixing water (wall)",
        "mixingWaterFloorLPerKg": "Mixing water (floor)",
        "prepCoverageM2Per10Kg": "Prep",
        "primerCoverageM2PerL": "Primer",
        "poolPrimerCoverageM2PerL": "Pool Primer",
        "presealerCoverageM2PerL": "Presealer",
        "sealerCoverageM2PerL": "Sealer",
        "heavyDutySealerCoverageM2PerL": "Heavy-Duty Sealer",
        "meshWasteFactor": "Mesh waste (simple)",
        "meshComplexWasteFactor": "Mesh waste (complex)",
        "generalWasteFactor": "General waste",
        "labourRatePerM2": "Rate / m²",
        "labourRatePerSurface": "Rate / surface",
        "labourRatePerProduct": "Rate / product",
        "complexityLow": "Low",
        "complexityNormal": "Normal",
        "complexityMedium": "Medium",
        "complexityHigh": "High",
        "repairMinSurfaceM2": "Repair min. surface (m²)",
        "prepMarginPercent": "Prep margin",
        "primerMarginPercent": "Primer margin",
        "poolPrimerMarginPercent": "Pool Primer margin",
        "coatingMarginPercent": "Coating margin",
        "meshMarginPercent": "Mesh margin",
        "presealerMarginPercent": "Presealer margin",
        "sealerMarginPercent": "Sealer margin",
        "heavyDutySealerMarginPercent": "HD Sealer margin",
        "pigmentMarginPercent": "Pigment margin"
      },
      "siteLogistics": "Site logistics",
      "maxSmallAccessCoatingBag": "Max coating bag size without large volume access",
      "materialMargin": "Material margins",
      "markups": {
        "title": "Site markups",
        "occupiedSite": "Occupied site (%)",
        "furnishedRoom": "Furnished room (%)",
        "standardFinishDiscount": "Standard finish discount (%)",
        "standardFinishDiscountHint": "Base labour rates are calibrated for Premium finish. This discount is applied when a section's finish is Standard."
      },
      "degressiveRates": "Degressive labour rates per m²",
      "addTier": "Add tier",
      "tierFields": {
        "minSurface": "Min surface",
        "maxSurface": "Max surface",
        "rate": "Rate (€/m²)",
        "enabled": "Enabled"
      }
    },
    "taskGenConfig": {
      "title": "Task generation variables",
      "save": "Save variables",
      "saveSuccess": "Task generation variables saved.",
      "saveError": "Save failed.",
      "unsavedWarning": "Unsaved changes. Click Save to apply to future generations.",
      "critical": "Critical",
      "taskFamilies": {
        "title": "Enable task families",
        "description": "Disabling a family prevents these tasks from being generated in new projects. Existing tasks are not removed.",
        "preparation": "Substrate preparation",
        "primer": "Primer",
        "mesh": "Mesh / Grid",
        "coating": "Finishing layers",
        "drying": "Drying time",
        "presealer": "Presealer",
        "sealer": "Sealer",
        "heavyDuty": "Heavy-Duty Sealer",
        "qualityControl": "Quality control",
        "aftercare": "Aftercare / protection",
        "handover": "Client handover (Handover)"
      },
      "substratePrep": {
        "title": "Substrate preparation",
        "inspection": "Substrate inspection",
        "surfaceCleaning": "Surface cleaning",
        "sanding": "Sanding",
        "dustRemoval": "Dust removal",
        "maskingProtection": "Protection of adjacent areas",
        "crackTreatment": "Crack treatment",
        "jointTreatment": "Joint treatment",
        "maxImperfectionMm": "Max imperfection",
        "maxImperfectionHint": "Threshold above which a fill task is generated"
      },
      "primer": {
        "title": "Primer",
        "minWaitMinutes": "Min. wait — standard primer",
        "minWaitHint": "Minimum delay before applying the first coat",
        "maxWindowHours": "Max window — standard primer",
        "maxWindowHint": "The coat must be applied before this duration",
        "poolMinWaitMinutes": "Min. wait — pool primer",
        "poolMinWaitHint": "Pool Primer — minimum wait before coating"
      },
      "mixing": {
        "title": "Mixing and layers",
        "mixRestMinutes": "Mix rest",
        "mixRestHint": "Rest time after mixing before application",
        "wallWaterRatio": "Wall water ratio",
        "floorWaterRatio": "Floor water ratio",
        "baseLayerThickness": "Base layer thickness",
        "finishLayerThickness": "Finish layer thickness"
      },
      "mesh": {
        "title": "Mesh / Grid",
        "overlapCm": "Mesh overlap",
        "edgeDistanceCm": "Mesh edge distance",
        "requiredFor": "Mesh required for",
        "floors": "Floors",
        "stairs": "Stairs",
        "tiles": "Tiles",
        "wood": "Wood",
        "pools": "Pools",
        "bathrooms": "Bathrooms",
        "exteriors": "Facades / exterior"
      },
      "waterproofing": {
        "title": "Waterproofing",
        "description": "Mas Maya coating is water-resistant but not waterproof. A waterproofing membrane is required in the following cases.",
        "wetZones": "Membrane required — wet zones",
        "wetZonesHint": "Wet zones, direct water exposure",
        "pools": "Membrane required — pools",
        "bathrooms": "Membrane required — bathrooms"
      },
      "presealer": {
        "title": "Presealer",
        "numberOfCoats": "Number of coats",
        "waitBetweenCoats": "Wait between coats"
      },
      "sealer": {
        "title": "Standard sealer",
        "ratioA": "Ratio A",
        "ratioAHint": "Part A of the mix (e.g. 5)",
        "ratioB": "Ratio B",
        "ratioBHint": "Part B of the mix (e.g. 1)",
        "mixRestMinutes": "Mix rest",
        "numberOfCoats": "Number of coats",
        "waitBetweenCoats": "Wait between coats",
        "fullCureHours": "Full cure"
      },
      "heavyDuty": {
        "title": "Heavy-Duty Sealer",
        "ratioA": "Ratio A",
        "ratioB": "Ratio B",
        "waitBetweenCoats": "Wait between coats",
        "fullCureHours": "Full cure",
        "minTempC": "Min. application temp.",
        "maxTempC": "Max. application temp.",
        "requiredFor": "Heavy-Duty required for",
        "floors": "Floors",
        "stairs": "Stairs",
        "exteriors": "Exterior",
        "pools": "Pools",
        "highTraffic": "High traffic zones"
      },
      "pool": {
        "title": "Pool rules",
        "fillWaitDays": "Wait before filling",
        "fillWaitHint": "Minimum duration before filling the pool",
        "waterlineMarginCm": "HD waterline margin",
        "waterlineMarginHint": "Width of the Heavy-Duty zone around the waterline"
      },
      "exterior": {
        "title": "Exterior rules",
        "minTempC": "Min. temperature",
        "maxTempC": "Max. temperature"
      },
      "aftercare": {
        "title": "Aftercare and usage restrictions",
        "noWaterDays": "Absolute protection",
        "noWaterHint": "No contact or moisture",
        "noTrafficDays": "No traffic",
        "lightUseStartDay": "Light use from day",
        "normalUseAfterDays": "Normal use after",
        "resealYearsMin": "Re-sealing recommended within",
        "resealYearsMax": "Re-sealing recommended before"
      },
      "layerExceptions": {
        "title": "Single / double layer exceptions",
        "description": "The standard Mas Maya system is 2mm base coat + mesh + 2mm finish. These exceptions should only be enabled for ideal dry interior surfaces.",
        "allowOneLayer": "Allow single-layer no-mesh system",
        "allowOneLayerHint": "Perfect dry interior walls only",
        "oneLayerWalls": "Single-layer allowed on walls",
        "oneLayerCeilings": "Single-layer allowed on ceilings",
        "allowTwoLayer": "Allow two-layer no-mesh system",
        "allowTwoLayerHint": "Stable textured walls only",
        "twoLayerStableWalls": "Two-layer no-mesh on stable textured walls"
      },
      "underfloorHeating": {
        "title": "Underfloor heating",
        "warning": "Modifying restart parameters may impact coating performance. Only modify these values based on the Mas Maya technical documentation.",
        "generationTitle": "Generation",
        "generateTasks": "Generate underfloor heating tasks",
        "requireQuestion": "Ask heating question for floor sections",
        "generateShutdown": "Heating shutdown task",
        "generateRestart": "Heating restart tasks",
        "generateProgressiveHeatUp": "Progressive heat-up (tasks per day)",
        "generateMonitoring": "Temperature monitoring tasks",
        "generateClientHandover": "Client instructions handover",
        "shutdownTitle": "Shutdown before application",
        "shutdownBeforeApplication": "Shutdown hours before application",
        "shutdownBeforeSealer": "Shutdown hours before sealer",
        "offDuringApplication": "Heating off during application",
        "offDuringCure": "Heating off during cure",
        "restartTitle": "Progressive restart",
        "restartAfterSealer": "Wait after final sealer before restart",
        "restartStartTemp": "Start temperature",
        "restartTempIncrement": "Increment per day",
        "restartMaxTemp": "Maximum temperature",
        "restartMinDuration": "Minimum ramp-up duration",
        "restartRequiresValidation": "Validation required at completion",
        "controlsTitle": "Controls",
        "dailyTempCheck": "Daily temperature check",
        "floorSurfaceTempCheck": "Floor surface check before restart",
        "clientWarningRapidHeatUp": "Client warning about rapid heat-up",
        "restartCompletionQc": "Final QC after restart"
      }
    },
    "roomCalculation": {
      "title": "Room calculation",
      "subtitle": "Coefficients and parameters for surface calculation of Room-type sections",
      "resetTitle": "Reset parameters",
      "resetConfirm": "All values will be replaced with defaults. This action is irreversible.",
      "surfaceCoefficients": {
        "title": "Surface coefficients",
        "subtitle": "Multipliers applied to the floor area to calculate material quantities",
        "walls": "Walls",
        "wallsFormula": "walls_surface = floor_m² × (height_coeff − ceiling_coeff)",
        "wallsNote": "The walls coefficient is derived automatically from the height and ceiling coefficients.",
        "floorCoeff": "Floor coefficient",
        "floorCoeffDesc": "Floor area multiplier (default = 1)",
        "ceilingCoeff": "Ceiling coefficient",
        "ceilingCoeffDesc": "Ceiling area multiplier (default = 1)"
      },
      "calculationMode": {
        "title": "Default calculation mode",
        "label": "Calculation method",
        "description": "Mode used by default when creating a Room section",
        "method1": "Method 1 — Quick coefficient",
        "method2": "Method 2 — Exact dimensions",
        "method3": "Method 3 — Premium adjusted"
      },
      "heightCoefficients": {
        "title": "Height coefficients",
        "subtitle": "Global surface coefficient = floor_m² × coefficient (quick method)"
      },
      "geometricMultipliers": {
        "title": "Geometric multipliers",
        "subtitle": "Adjustment factors by room type",
        "colType": "Type",
        "colLabel": "Label",
        "colMin": "Min",
        "colDefault": "Default",
        "colMax": "Max"
      },
      "openingDeductions": {
        "title": "Opening deduction rules",
        "standardDoors": "Deduct standard doors",
        "standardWindows": "Deduct standard windows",
        "largeBays": "Deduct large bay windows",
        "shopfronts": "Deduct shopfronts",
        "largeGlassPartitions": "Deduct large glass partitions",
        "thresholdLabel": "Large opening deduction threshold (m²)",
        "thresholdDesc": "Openings beyond this threshold are deducted if the corresponding rule is enabled"
      },
      "detailAdditions": {
        "title": "Detail additions",
        "subtitle": "Addition percentage for architectural details (returns, niches, beams, coffers, pillars…)",
        "min": "Minimum addition (%)",
        "default": "Default addition (%)",
        "max": "Maximum addition (%)"
      },
      "siteConditions": {
        "title": "Site condition multipliers",
        "subtitle": "Additions applied based on site occupancy status",
        "occupied": "Occupied / furnished site",
        "luxury": "Luxury / ultra premium site",
        "minimum": "Minimum (%)",
        "maximum": "Maximum (%)"
      },
      "heightAccess": {
        "title": "Height / access multipliers",
        "subtitle": "Additions applied based on ceiling height (access, scaffolding)",
        "standardHeight": "Standard height (0%)",
        "noAddition": "0% — no addition"
      },
      "specialFormulas": {
        "title": "Special geometric formulas",
        "beams": "Beams",
        "beamsFormula": "surface = length × Σ visible faces",
        "beamsNote": "Add each visible face (underside, sides) × length",
        "pillars": "Pillars",
        "pillarsFormula": "surface = perimeter × height",
        "pillarsNote": "Perimeter = sum of exposed faces",
        "slopedCeilings": "Sloped / raked ceilings",
        "slopedCeilingsFormula": "actual surface = projected surface / cos(angle)",
        "slopedCeilingsNote": "Angle is measured from horizontal",
        "niches": "Niches",
        "nichesFormula": "back + left side + right side + top + bottom + returns",
        "nichesNote": "Enter each face individually"
      }
    },
    "milestoneWorkflowDesigner": {
      "title": "Workflow Designer",
      "subtitle": "Configure the default milestone journey applied to each new project.",
      "addMilestone": "Add milestone",
      "saveMilestone": "Save",
      "delete": "Delete",
      "unsavedChanges": "Unsaved changes",
      "sections": {
        "identity": "Identity",
        "triggerEngine": "Trigger Engine",
        "clientVisibility": "Client Visibility",
        "approvalGate": "Approval Gate",
        "payment": "Payment",
        "applicability": "Applicability",
        "photoRules": "Photo Rules",
        "automation": "Automation",
        "notifications": "Notifications"
      },
      "fields": {
        "customTitle": "Custom title",
        "color": "Color",
        "icon": "Icon",
        "type": "Type",
        "scope": "Scope",
        "triggerType": "Trigger",
        "triggerCategories": "Trigger categories",
        "blocksCategories": "Blocked categories",
        "isVisibleToClient": "Visible to client",
        "notifyClient": "Notify client",
        "showPhotosToClient": "Show photos to client",
        "showProgress": "Show progress",
        "requiresClientApproval": "Requires client approval",
        "paymentType": "Payment type",
        "paymentPercent": "Percentage (%)",
        "paymentAmount": "Amount (€)",
        "appliesToRenovation": "Renovation",
        "appliesToNewBuild": "New build",
        "appliesToExternalOnly": "DIY / External",
        "appliesToManaged": "Mas Maya Managed",
        "appliesToExecuted": "Mas Maya Executed",
        "requirePhotos": "Require photos",
        "minPhotos": "Minimum photos",
        "photosVisibleToClient": "Photos visible to client",
        "autoComplete": "Auto-complete",
        "autoNotifyClient": "Auto-notify client",
        "autoLockDependentTasks": "Auto-lock dependent tasks",
        "autoUnlockAfterApproval": "Auto-unlock after approval",
        "notifyWorker": "Notify worker",
        "notifyQm": "Notify QM",
        "notifyPm": "Notify PM"
      },
      "types": {
        "Progress": "Progress",
        "Approval": "Approval",
        "Payment": "Payment"
      },
      "scopes": {
        "Project": "Project",
        "Section": "Section"
      },
      "triggerTypes": {
        "AllCategoriesCompleted": "All categories completed",
        "FirstTaskStarted": "First task started",
        "ProjectArchived": "Project archived",
        "Manual": "Manual"
      },
      "paymentTypes": {
        "None": "None",
        "Percent": "Percentage",
        "Fixed": "Fixed amount"
      },
      "categories": {
        "preparation": "Preparation",
        "primer": "Primer",
        "mesh": "Mesh",
        "baseLayer": "Base layer",
        "finishingLayer": "Finishing layer",
        "smoothing": "Smoothing",
        "presealer": "Presealer",
        "sealer": "Sealer",
        "heavyDutySealer": "Heavy-Duty Sealer",
        "curing": "Curing",
        "delivery": "Delivery",
        "inspection": "Inspection",
        "handover": "Handover",
        "custom": "Custom"
      },
      "executionModes": {
        "externalOnly": "DIY / External",
        "managed": "Mas Maya Managed",
        "executed": "Mas Maya Executed"
      },
      "projectTypes": {
        "renovation": "Renovation",
        "newBuild": "New build"
      }
    },
    "milestoneTemplateConfig": {
      "title": "Milestone Templates",
      "description": "These settings define the milestones automatically created on each new Mas Maya project.",
      "projectMilestones": "Project milestones",
      "sectionMilestones": "Per-surface milestones",
      "save": "Save",
      "saveSuccess": "Configuration saved.",
      "saveError": "Error saving configuration.",
      "unsavedWarning": "You have unsaved changes.",
      "m1": {
        "label": "Project started",
        "hint": "Automatically completed when the first task is started."
      },
      "m2": {
        "label": "Preparation completed",
        "hint": "Completed when all Preparation and Primer tasks are done."
      },
      "m3": {
        "label": "Surface approval",
        "hint": "Triggered per section when finishing layers are done. Blocks presealer until approved.",
        "requiresClientApproval": "Client approval required",
        "requiresClientApprovalHint": "The client receives a unique link to approve or reject each surface."
      },
      "m4": {
        "label": "Protection completed",
        "hint": "Completed when all Presealer, Sealer and Heavy-Duty Sealer tasks are done."
      },
      "m5": {
        "label": "Delivery",
        "hint": "Automatically completed when the project is archived. Can include a payment.",
        "paymentType": "Payment type",
        "paymentNone": "None",
        "paymentPercent": "Percentage",
        "paymentFixed": "Fixed amount",
        "paymentPercentLabel": "Percentage (%)",
        "paymentAmountLabel": "Amount (€)"
      }
    }
  },
  "staff": {
    "title": "Staff",
    "createButton": "New Staff Member",
    "createTitle": "Add Staff Member",
    "noData": "No staff members found",
    "manager": "Manager",
    "setManager": "Promote to manager",
    "removeManager": "Remove manager role",
    "showInactive": "Show inactive",
    "managers": "Managers",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "columns": {
      "name": "Name",
      "email": "Email",
      "status": "Status",
      "manager": "Manager"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "sections": {
      "profile": "Profile"
    },
    "teaching": {
      "title": "Teacher Certification",
      "becomeTeacher": "This employee is also a teacher",
      "certifyTitle": "Certify as teacher",
      "editTitle": "Edit certification",
      "editCertification": "Edit certification"
    },
    "schedule": {
      "title": "Schedule",
      "date": "Date",
      "startTime": "Start time",
      "endTime": "End time",
      "type": "Type",
      "project": "Project",
      "notes": "Notes",
      "addEntry": "Add entry",
      "empty": "No schedule entries",
      "removeTitle": "Remove entry",
      "removeConfirm": "Are you sure you want to remove this schedule entry?"
    },
    "scheduleType": {
      "ProjectAssignment": "Project assignment",
      "TrainingSession": "Training session",
      "Unavailable": "Unavailable"
    },
    "assignedProjects": "Assigned projects",
    "noAssignedProjects": "No assigned projects",
    "rolePM": "Project Manager",
    "roleBackupPM": "Backup Project Manager",
    "form": {
      "notes": "Notes",
      "firstName": "First name",
      "firstNamePlaceholder": "John",
      "lastName": "Last name",
      "lastNamePlaceholder": "Doe",
      "emailRequired": "Email is required",
      "firstNameRequired": "First name is required",
      "lastNameRequired": "Last name is required",
      "email": "Email"
    }
  },
  "structures": {
    "title": "Structure",
    "type": "Structure type",
    "noStructure": "No structure defined",
    "define": "Define structure",
    "computedSurface": "Computed surface",
    "computedVolume": "Computed volume",
    "deleteTitle": "Delete structure",
    "deleteConfirm": "Delete the structure definition for this section? The surface area will not be recalculated."
  },
  "calendar": {
    "title": "Calendar",
    "mode": {
      "project": "By project",
      "staff": "By employee"
    },
    "labels": {
      "today": "Today",
      "day": "Day",
      "week": "Week",
      "month": "Month",
      "year": "Year"
    },
    "filters": {
      "categories": "Show",
      "allProjects": "All projects",
      "selectProject": "Select a project",
      "selectStaff": "Select an employee",
      "allStatuses": "All statuses",
      "allStepTypes": "All step types",
      "allStaff": "All staff",
      "allAccounts": "All accounts"
    },
    "categories": {
      "ProjectStep": "Project step",
      "DryingPeriod": "Drying",
      "CuringPeriod": "Curing",
      "Delivery": "Delivery",
      "Training": "Training",
      "StaffSchedule": "Staff",
      "Supervision": "Supervision",
      "Personal": "Personal",
      "ProjectTask": "Project task"
    },
    "taskStatuses": {
      "Todo": "To do",
      "InProgress": "In progress",
      "SubmittedForReview": "Submitted for review",
      "ValidatedAsTechnicallyCompliant": "Validated",
      "RejectedWithCorrectionRequired": "Rejected — correction required",
      "Blocked": "Blocked"
    },
    "taskCategories": {
      "Preparation": "Preparation",
      "Primer": "Primer",
      "Mesh": "Mesh",
      "BaseLayer": "Base layer",
      "FinishingLayer": "Finishing layer",
      "Smoothing": "Smoothing",
      "Presealer": "Presealer",
      "Sealer": "Sealer",
      "HeavyDutySealer": "Heavy duty sealer",
      "Curing": "Curing",
      "Delivery": "Delivery",
      "Inspection": "Inspection",
      "Handover": "Handover",
      "Custom": "Custom"
    },
    "taskPriorities": {
      "Low": "Low",
      "Normal": "Normal",
      "High": "High",
      "Critical": "Critical"
    },
    "stepTypes": {
      "SubstratePreparation": "Substrate prep",
      "PrimerApplication": "Primer",
      "BaseLayer": "Base layer",
      "MeshInstallation": "Mesh install",
      "FinishingCoat": "Finishing coat",
      "Smoothing": "Smoothing",
      "Presealer": "Pre-sealer",
      "Sealer": "Sealer",
      "HeavyDutySealer": "Heavy-duty sealer",
      "CuringStep": "Curing",
      "ProtectionPeriod": "Protection period",
      "Handover": "Handover"
    },
    "stepStatuses": {
      "Planned": "Planned",
      "InProgress": "In progress",
      "Completed": "Completed",
      "Blocked": "Blocked",
      "ValidationPending": "Validation pending",
      "CorrectionRequired": "Correction required",
      "Cancelled": "Cancelled"
    },
    "deliveryTypes": {
      "OrderConfirmed": "Order confirmed",
      "OrderPrepared": "Order prepared",
      "DeliveryExpected": "Delivery expected",
      "DeliveryDelayed": "Delivery delayed",
      "DeliveryCompleted": "Delivered"
    },
    "deliveryStatuses": {
      "Pending": "Pending",
      "InTransit": "In transit",
      "Delivered": "Delivered",
      "Delayed": "Delayed",
      "Cancelled": "Cancelled"
    },
    "scheduleEntryTypes": {
      "ProjectAssignment": "Project assignment",
      "TrainingSession": "Training session",
      "Unavailable": "Unavailable"
    },
    "detail": {
      "start": "Start",
      "end": "End",
      "project": "Project",
      "section": "Section",
      "stepType": "Step type",
      "status": "Status",
      "blocked": "Blocked",
      "drying": "Drying period",
      "curing": "Curing period",
      "deliveryType": "Delivery type",
      "deliveryStatus": "Delivery status",
      "trackingNumber": "Tracking number",
      "carrier": "Carrier",
      "location": "Location",
      "staffMember": "Staff member",
      "entryType": "Entry type",
      "notes": "Notes",
      "deleteConfirm": "Are you sure you want to delete this event? This action cannot be undone.",
      "taskStatus": "Status",
      "taskCategory": "Category",
      "taskPriority": "Priority",
      "assignedApplicator": "Applicator",
      "assignedManager": "Project manager",
      "validationRequired": "Validation required",
      "noPlannedDate": "No planned date — placed at project start date"
    },
    "modal": {
      "createStep": "Create project step",
      "editStep": "Edit project step",
      "createDelivery": "Create delivery",
      "editDelivery": "Edit delivery",
      "project": "Project",
      "stepType": "Step type",
      "customTitle": "Custom title",
      "customTitlePlaceholder": "Leave blank to use step type name",
      "date": "Date",
      "startTime": "Start time",
      "endTime": "End time",
      "dryingHours": "Drying (hours)",
      "curingHours": "Curing (hours)",
      "status": "Status",
      "notes": "Notes",
      "isBlocked": "Blocked",
      "blockedReason": "Blocked reason",
      "deliveryType": "Delivery type",
      "deliveryStatus": "Status",
      "expectedDate": "Expected date",
      "actualDate": "Actual delivery date",
      "trackingNumber": "Tracking number",
      "carrier": "Carrier"
    }
  },
  "supervision": {
    "title": "Supervision",
    "tabs": {
      "comments": "Comments",
      "observations": "Observations",
      "escalations": "Escalations",
      "history": "History"
    },
    "visibility": {
      "label": "Visibility",
      "ClientVisible": "Client visible",
      "TeamVisible": "Team only",
      "InternalOnly": "Internal only"
    },
    "comments": {
      "empty": "No comments yet.",
      "newPlaceholder": "Write a comment…",
      "replyPlaceholder": "Write a reply…",
      "send": "Send",
      "reply": "Reply",
      "deleted": "[deleted]"
    },
    "observations": {
      "empty": "No observations recorded.",
      "open": "open",
      "resolvedCount": "resolved",
      "add": "Add observation",
      "titleLabel": "Title",
      "bodyLabel": "Description",
      "severityLabel": "Severity",
      "by": "by",
      "resolved": "Resolved",
      "resolve": "Mark as resolved",
      "confirmResolve": "Confirm",
      "resolutionNote": "Resolution note",
      "resolveNotePlaceholder": "Describe how this was resolved…",
      "severity": {
        "Info": "Info",
        "Warning": "Warning",
        "Critical": "Critical"
      }
    },
    "escalations": {
      "empty": "No escalations.",
      "open": "open",
      "resolvedCount": "resolved",
      "new": "New escalation",
      "subjectLabel": "Subject",
      "bodyLabel": "Description",
      "submit": "Submit",
      "by": "by",
      "assignedTo": "Assigned to",
      "resolution": "Resolution",
      "resolutionLabel": "Resolution note",
      "statusLabel": "New status",
      "updateStatus": "Update status",
      "status": {
        "Open": "Open",
        "Acknowledged": "Acknowledged",
        "Resolved": "Resolved"
      }
    },
    "auditLog": {
      "empty": "No activity recorded yet.",
      "loadMore": "Load more",
      "actions": {
        "ProjectCreated": "created the project",
        "ProjectUpdated": "updated the project",
        "ProjectStatusChanged": "changed project status",
        "ProjectDeleted": "deleted the project",
        "StepCreated": "created a step",
        "StepUpdated": "updated a step",
        "StepStatusChanged": "changed step status",
        "StepDeleted": "deleted a step",
        "StepBlocked": "blocked a step",
        "StepUnblocked": "unblocked a step",
        "StepValidated": "validated a step",
        "StepRejected": "rejected a step",
        "DeliveryCreated": "created a delivery",
        "DeliveryUpdated": "updated a delivery",
        "DeliveryStatusChanged": "changed delivery status",
        "DeliveryDeleted": "deleted a delivery",
        "ApplicatorAssigned": "assigned an applicator",
        "ApplicatorRemoved": "removed an applicator",
        "TeamMemberAssigned": "assigned a team member",
        "TeamMemberRemoved": "removed a team member",
        "BackupPmAssigned": "assigned a backup PM",
        "ClientLinked": "linked a client",
        "DocumentUploaded": "uploaded a document",
        "DocumentDeleted": "deleted a document",
        "CommentAdded": "added a comment",
        "CommentDeleted": "deleted a comment",
        "ObservationAdded": "recorded an observation",
        "ObservationResolved": "resolved an observation",
        "EscalationCreated": "created an escalation",
        "EscalationAcknowledged": "acknowledged an escalation",
        "EscalationResolved": "resolved an escalation"
      }
    }
  },
  "roles": {
    "GlobalAdmin": "Global Admin",
    "Admin": "Admin",
    "ProjectManager": "Project Manager",
    "BackupProjectManager": "Backup Project Manager",
    "MasMayaApplicator": "Mas Maya Applicator",
    "ReferencedInstaller": "Referenced Installer",
    "IndividualClient": "Individual Client",
    "ProfessionalClient": "Professional Client"
  },
  "userManagement": {
    "title": "User Management",
    "users": "users",
    "searchPlaceholder": "Search by name or email…",
    "noRoles": "No roles assigned",
    "noUsers": "No users found",
    "addRole": "Add role",
    "impersonate": "Impersonate",
    "impersonatingAs": "Impersonating as {{name}}",
    "stopImpersonating": "Stop impersonating",
    "columns": {
      "user": "User",
      "roles": "Roles",
      "entities": "Entities"
    },
    "removeRole": {
      "title": "Remove role",
      "confirm": "Remove role {{role}} from {{user}}?"
    }
  },
  "shop": {
    "nav": "Shop",
    "hero": {
      "title": "Finishing Systems",
      "subtitle": "Coatings, Primers & Accessories",
      "description": "Architectural finishing materials for demanding craftsmen."
    },
    "allProducts": "All products",
    "searchPlaceholder": "Search products...",
    "noResults": "No products found",
    "filterBy": "Filter by",
    "sortBy": "Sort by",
    "sort": {
      "nameAsc": "Name (A–Z)",
      "priceAsc": "Price: low to high",
      "priceDesc": "Price: high to low"
    },
    "addToCart": "Add to cart",
    "addedToCart": "Added to cart",
    "viewDetails": "View product",
    "backToShop": "Back to shop",
    "relatedProducts": "Complementary products",
    "systemNote": "These products are part of a complete application system.",
    "selectContact": "Select a client",
    "selectContactHint": "Choose a client to manage their cart.",
    "cartFor": "Cart for",
    "openCart": "View cart",
    "cart": {
      "title": "Cart",
      "empty": "The cart is empty.",
      "checkout": "Checkout",
      "orderOnMasmaya": "Order on masmaya.com"
    },
    "qty": "Qty",
    "details": {
      "category": "Category",
      "variant": "Variant",
      "color": "Color",
      "sizeWeight": "Size / Weight",
      "dimensions": "Dimensions",
      "sku": "Reference",
      "price": "Price",
      "technical": "Technical information"
    }
  },
  "applicatorProfiles": {
    "title": "Applicator Profiles",
    "createTitle": "Create Applicator Profile",
    "moderateTitle": "Moderate Portfolio Entry",
    "form": {
      "contactId": "Contact ID",
      "contactIdPlaceholder": "Paste the contact UUID",
      "contactIdRequired": "Contact ID is required",
      "displayName": "Display Name",
      "displayNameRequired": "Display name is required",
      "companyName": "Company Name",
      "bio": "Bio",
      "city": "City",
      "country": "Country (2-letter code)",
      "travelRadius": "Travel radius (km)",
      "yearsExperience": "Years of experience",
      "availability": "Availability",
      "specialties": "Specialties",
      "styleTags": "Style Tags",
      "technicalTags": "Technical Systems",
      "note": "Note (visible to admin only)",
      "newStatus": "New Status"
    },
    "availability": {
      "Available": "Available",
      "PartiallyBooked": "Partially Booked",
      "Unavailable": "Unavailable"
    },
    "moderation": {
      "PendingReview": "Pending Review",
      "Approved": "Approved",
      "Rejected": "Rejected",
      "Hidden": "Hidden",
      "Featured": "Featured"
    },
    "currentStatus": "Current status:",
    "deleteConfirm": "Delete this applicator profile?",
    "deleteTitle": "Delete Profile"
  }
}
